import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';

import { mobiscroll, MbscDatetimeOptions, MbscFormOptions } from '@mobiscroll/angular';
import { CurrencyPipe, DatePipe, DecimalPipe, formatCurrency, getCurrencySymbol } from '@angular/common';
import * as alertifyjs from 'alertifyjs';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { async } from '@angular/core/testing';
import { FormBuilder, Validators } from '@angular/forms';
import { UserService } from 'src/app/services/user/user.service';
import { filtrarPorEmpresa } from 'src/app/pipes/empresa-cuenta.pipe';
import { empresaActiva, activasPrimero } from 'src/app/utils/empresa-activa';
import { DomSanitizer } from '@angular/platform-browser';
import { RedirecFormService } from 'src/app/services/redirec-form.service';
import { SocketioService } from 'src/app/services/socket/socketio.service';
import { Location } from '@angular/common';
import { LocationServiceService } from '../../services/location-service.service';
import { FeeService } from 'src/app/services/fee.service';
import { avisoCuentaContrato } from 'src/app/utils/aviso-cuenta-contrato';
import Swal from 'sweetalert2';

mobiscroll.settings = {
  lang: 'es',
  theme: 'ios',
  themeVariant: 'light'
};


@Component({
  selector: 'app-post',
  templateUrl: './post.component.html',
  styleUrls: ['./post.component.css'],
  providers: [DecimalPipe,CurrencyPipe,DatePipe],

})

export class PostComponent implements OnInit {

  typeProduct:any = '';

  remanente:any;
  reference_default_length = 6;
  reference_length = 6;
  reference_length_max = 6;
  accounts:any;
  dueBalance:any = 0;
  dueBalanceCurrecy:any = 0;

  responseTransaction:any = {};
  formData: any = {
    formaPago: "",
    cuenta: "",
    pais: "",
    monto: this.updateValueCurrency('0'),
    descripcion: "",
    upload:null,

  };

  errorMessage = 'Error message!;'
  validationReference:any = false;
  validationAccountNumber:any = false;

  validationPhone:any = false;
  type: any;

  confirm = false;
  confirmLoading = false;
  ordernumber:any;
  typeProducts:any = [];

  isWidgetMode = false;
  selectView: any = 1;
  selectMaxView: any = 2;
  banks:any = [];
  formDataUpload:any = null;
  fileName = '';
  @Input() code_person: any;

  queryParams: any;
  loading: any = true; // Inicializar como true para evitar el flash inicial
  person: any;

  form:any;
  installment:any;


  amountF:any = 0;
  amountFB:any = 0;
  amountFB_bs:any = 0;

  totalpaymentReference = 0;
  deuda_total = 0;

  payments = [];
  paymentsReference = [];
  accountPayment:any;
  accountPaymentOrigin:any =[];

  accountPayment_load:any;
  account:any;
  account_payment:any;
  rate :any;
  regx_total_amount = "^(([0-9]*)|(([0-9]*)\.([0-9]*)))$"

  date_base: any = new Date;
  date_base_string :any;
  deductions_payment : any = {};
  productArray:any[] = [];



  mobileSettingsFile: MbscDatetimeOptions = {
    display: 'bottom'
};

  mobileSettings: MbscDatetimeOptions = {
      display: 'bottom',
      themeVariant: 'dark',
  };


  desktopSettings: MbscDatetimeOptions = {
      display: 'bubble',
      touchUi: false
  };

  formSettings: MbscFormOptions = {
      inputStyle: 'box'
  };

  rate_load:any;
  rate_error:any;
  deduction_payment:any;
  paymentEdit:any;
  invoiceParams:any;
  installmentParams:any;
  feeParams:any;
  latitude = 0;
  longitude = 0;


  multipago:any = false;
  code_person_url:any;
  code_concept_deduction: any;

  concept_deduction_apply: any = [];

  fee_to_apply: any;

  fee_later_payment_code = 'C001';
  fee_installment_extend = 'C002';

  // ================================================================================
  // PROPIEDADES FLUJO SIMPLIFICADO BDV - Workflow Verificación
  // ================================================================================
  
  simplifiedFlow = {
    enabled: false,
    step: 'phone', // 'phone' → 'amount' → 'verify' → ['reference'] → 'confirm' → 'upload' → 'register'
    loading: false,
    data: {
      phoneCode: null as string | null,
      phoneNumber: null as string | null,
      amount: null as string | null,
      reference: null as string | null,
      paymentToken: null as string | null,
      file: null as any
    },
    verification: {
      matches: null as 'none' | 'unique' | 'multiple' | null,
      paymentData: null as any,
      requiresReference: false
    },
    errors: {
      phone: '',
      amount: '',
      reference: '',
      file: ''
    }
  };

  // ================================================================================
  // DEBOUNCE PARA BÚSQUEDA AUTOMÁTICA BDV - Evitar múltiples llamados
  // ================================================================================
  private autoSearchDebounceTimer: any = null;
  private readonly DEBOUNCE_DELAY = 800; // 800ms de espera después del último cambio
  private lastAmountValue: any = null; // Seguimiento del último valor de monto para detectar cambios reales

  minAmount = 0;
  validationMinAmount = true;

  fee_delete: any = [];

  // Nuevo input con botón aplicar
  inputValue: string = '';

  // Propiedades para búsqueda en modal
  searchTerm: string = '';
  filteredAccounts: any[] = [];
  // Filtro de empresa de las cuentas (solo visual); arranca en la empresa del switch (getAccountPayment)
  empresaFiltro: 'CrediTotal' | 'Mundo Total' | 'Todas' = 'Todas';
  get cuentasVisibles(): any[] { return filtrarPorEmpresa(this.filteredAccounts, this.empresaFiltro); }
  setEmpresaFiltro(e: 'CrediTotal' | 'Mundo Total' | 'Todas') { this.empresaFiltro = e; }

  // Propiedades para búsqueda de productos
  productSearchTerm: string = '';
  filteredProductArray: any[] = [];
  showProductDropdown: boolean = false;

  // Propiedades para códigos dinámicos
  allDynamicCodes: any[] = [];
  bankAccountCodes: any[] = [];

  // Getter para verificar si se ha seleccionado un tipo de producto
  get isProductTypeSelected(): boolean {
    return this.typeProduct &&
           this.typeProduct.trim() !== '' &&
           this.typeProduct !== 'undefined' &&
           this.typeProduct !== 'null';
  }

  // Getter para verificar si se puede mostrar información de cuenta
  get canShowAccountInfo(): boolean {
    return this.isProductTypeSelected && this.account;
  }

  // Método para limpiar cuenta seleccionada
  clearSelectedAccount(): void {
    this.avisoConfirmado = false;
    this.account = null;
    this.account_payment = null;
    this.form.get('total_amount')?.setValue('');
    this.form.get('reference')?.setValue('');
    this.form.get('origin_account')?.setValue('');
    this.form.get('accountNumber')?.setValue('');
  }


  // Separación de contratos MT/CT: aviso al elegir una cuenta del contrato no activo.
  // El perfil activo viene con cada cuenta (campo perfil_activo); sin él, no hay aviso.
  avisoConfirmado = false;
  get avisoCuenta(): string | null { return avisoCuentaContrato(this.account, this.account?.perfil_activo); }

  constructor(
    private offcanvasService: NgbOffcanvas,
    private decimalPipe: DecimalPipe,
    private currencyPipe: CurrencyPipe,
    private router: Router,
    private route: ActivatedRoute,
    public _auth : AuthService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private _user: UserService,
    private sanitizer: DomSanitizer,
    private redirecFormService: RedirecFormService,
    public socketService: SocketioService,
    private datePipe: DatePipe,
    private location: Location,
    private locationService: LocationServiceService,
    public feeService: FeeService


  ) {

  }

  async ngOnInit() {
    this.getLocation();
    this.getTypeProducts();
    await this.consultAllProductsInvoices();
    // 💎 Establecer CREDIT como tipo de producto por defecto
    this.typeProduct = 'CREDIT';
    this.productSearchTerm = 'CREDIT';
    this.loadDynamicCodes(); // Cargar códigos dinámicos
    this.date_base_string = this.datePipe.transform(this.date_base, 'MM/dd/yyyy');

    // 💎 Cargar cuentas con el tipo de producto por defecto (CREDIT)
    await this.getAccountPayment();
    this.getDeduction_payment();
    this.getBanks();

    this.form = this.formBuilder.group({
      description: [''],
      reference: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
      code_identity: ['V'],
      identity: [''],
      total_amount: ['',[Validators.required,Validators.pattern(this.regx_total_amount)]],
      code_phone: ['0414'],
      phone: [''],
      origin_account: ["", [Validators.required]],
      accountNumber:[''],
      type_product:['']

    });

    this.validateReferenceLength();




    this.activatedRoute.params.subscribe( async params => {

      this.queryParams = params;

     if(localStorage.getItem('pe')){


      let paymentEdit:any = localStorage.getItem('pe');
      this.paymentEdit =  JSON.parse(paymentEdit);

      localStorage.removeItem('pe');

     // Resolver la cuenta COMPLETA desde la lista ya cargada (this.accountPayment) por su code.
     // Las vistas que disparan la edición (pagos general vs pagos POR PERSONA) traen account_payment
     // con distinto detalle: la de persona NO incluye currency → la moneda salía "Null" y no cargaba
     // la tasa. Resolviéndola desde la lista, el form siempre tiene currency/tasa correctos.
     const _accRaw = this.paymentEdit?.payment?.account_payment;
     const _accCode = (_accRaw && typeof _accRaw === 'object') ? _accRaw.code : _accRaw;
     const _fullAccount = (this.accountPayment || []).find((a: any) => a?.code === _accCode) || _accRaw;
     this.selectAccount2(_fullAccount);

     this.date_base = new Date(this.paymentEdit?.payment?.register_payment_date);

     this.date_base_string = this.datePipe.transform( this.date_base, 'MM/dd/yyyy');

      this.getPerson(this.paymentEdit?.payment?.owner?.code);

      // this.validateMinAmount();



      this.getRate(this.date_base_string,true);


      let temp = {
        total_amount :  this.paymentEdit?.payment?.counterValue || '',
        reference: this.paymentEdit?.payment?.paymentMethodId || '',
        origin_account:  this.paymentEdit?.payment?.bankCode || '',
        account:  this.paymentEdit?.payment?.account || '',
        code_identity : this.paymentEdit?.payment?.cid ? this.paymentEdit?.payment?.cid?.charAt(0) : 'V',
        identity : this.paymentEdit?.payment?.cid ? this.paymentEdit?.payment?.cid?.slice(1) : '',
        code_phone : this.paymentEdit?.payment?.phone ? this.paymentEdit?.payment?.phone?.slice(0, 4) : '',
        phone : this.paymentEdit?.payment?.phone ? this.paymentEdit?.payment?.phone?.slice(4) : ''

      }

      this.form = this.formBuilder.group({
        description: [''],
        reference: [temp.reference],
        code_identity: [temp.code_identity],
        identity: [temp.identity],
        total_amount: [temp.total_amount,[Validators.required,Validators.pattern(this.regx_total_amount)]],
        code_phone: [temp.code_phone],
        phone: [temp.phone],
        origin_account: [temp.origin_account, [Validators.required]],
        accountNumber:[temp.account],


     });

     this.validatePhone();
     this.validateNumberReference(this.reference_length, this.reference_length_max);



     }else{

      if (this.queryParams?.code_person && this.queryParams?.fee && this.queryParams?.installment) {
        this.code_person_url = this.queryParams?.code_person;
        this.feeParams = this.queryParams?.fee;
        this.installmentParams = this.queryParams?.installment;
        this.getPerson(this.code_person_url);

        this.getFeeExtend();
        this.getRate(null,true);


      }else if(this.queryParams?.code_person && this.queryParams?.code_person){
        this.code_person_url = this.queryParams?.code_person;
        this.code_concept_deduction = this.queryParams?.code_concept_deduction;
        this.getPerson(this.code_person_url);

        this.multipago = true;
        this.getRate(null,true);
      }else if(this.queryParams?.code_person ){
        this.code_person_url = this.queryParams?.code_person;
        this.getPerson(this.code_person_url);
        this.multipago = true;
        this.getRate(null,true);

      }else {
         this.router.navigate(['/'], {});

      }

     } ;


      this.queryParams = params;



    });


    const type = this.route.snapshot.paramMap.get('type') || "deposit" ;
    switch (type) {

      case 'deposit':
        this.type = 'depósito';
        break;

      case 'withdrawal':
        this.type = 'retiro';
        break;

    }




  }



  validateNumericInput(event: KeyboardEvent): void {
    const keyCode = event.keyCode;
    if ((keyCode < 48 || keyCode > 57) && keyCode!= 46) {
      event.preventDefault();
    }
  }

  validateReferenceLength(): void {

    const referenceControl = this.form.get('reference');
      referenceControl.clearValidators();

    referenceControl.setValidators([
      Validators.minLength(this.reference_length),
      Validators.maxLength(this.reference_length_max)
    ]);

    referenceControl.updateValueAndValidity();
  }


  getLocation() {
    this.locationService.getPosition().then(pos => {
      this.latitude = pos.lat;
      this.longitude = pos.lng;
    }).catch(err => {
      console.error('Error obteniendo la ubicación:', err);
    });
  }






  getDeduction_payment = async () => {

    try {
      const resp = await this._user.getDeduction_payment({});
      this.deduction_payment = resp.res;
    } catch (error) {
      console.log(error);

    }


  }


  private isLoadingPerson = false; // Flag para evitar llamadas duplicadas

  getPerson = async (code:any) => {
    // Evitar llamadas duplicadas simultáneas
    if (this.isLoadingPerson) {
      console.log('⚠️ getPerson ya está en ejecución, ignorando llamada duplicada');
      return;
    }

    this.isLoadingPerson = true;
    this.loading = true;
    try {
      const resp = await this._user.getPersonbyCode({ code });
      this.person = resp.resp;


      // si hay morosidad, lo mandamos por el flujo de fees
      if(this.person?.resumen?.aplica_fee > 0) {
        this.getFeeApply();
      }

      this.minAmount = this.minPayment();
    } catch (error) {
      // Optionally show an error message to the user
      // alertifyjs.error('Error al cargar los datos del cliente');
    } finally {
      this.loading = false;
      this.isLoadingPerson = false;
    }
  }


  birthdaySet(e: any) {
    if (e) {
      e.blur();
    }
  }

  selectInst(opt: any) {
    this.formData.instrumento = opt;
    this.offcanvasService.dismiss('Cross click');
    this.formData.monto = this.formData.instrumento.monto || this.updateValueCurrency('0');
  }

  onSet() {
    let s2 = this.formData?.instrumento?.monto;
    let s3 = s2.replace(",", "");
    const x = (this.formData.cantidad * parseFloat(s3)).toFixed(2);
    this.formData.monto = this.decimalPipe.transform(x, '1.2-2');
  }


  // Método para validar campos requeridos en flujo tradicional
  validateRequiredFieldsForTraditionalFlow(): boolean {
    const isLiquidacion = this.account && (
      this.account.bank?.name?.toLowerCase().includes('liquidacion') || 
      this.account.bank?.name?.toLowerCase().includes('liquidación') ||
      this.account.bank?.description?.toLowerCase().includes('liquidacion') ||
      this.account.bank?.description?.toLowerCase().includes('liquidación') ||
      this.account.number?.toLowerCase().includes('liquidacion') ||
      this.account.number?.toLowerCase().includes('liquidación')
    );
    const isCustomer = this.account?.type_customer === 'CUSTOMER';
    const isPagoMovil = this.account?.payment_method?.code === 'PAGO_MOVIL';
    const isZelle = this.account?.bank?.name === 'Zelle';
    const isDepositoEfectivo = this.account?.payment_method?.code === 'DEPOSITO_BS';
    
    console.log('🔍 [LIQUIDACION] validateRequiredFieldsForTraditionalFlow:', {
      bank_name: this.account?.bank?.name,
      bank_description: this.account?.bank?.description,
      account_number: this.account?.number,
      payment_method_code: this.account?.payment_method?.code,
      isLiquidacion,
      isDepositoEfectivo,
      isCustomer,
      isPagoMovil,
      isZelle,
      hasOriginAccount: !!this.form?.get('origin_account')?.value,
      validationPhone: this.validationPhone,
      validationReference: this.validationReference
    });
    console.log('🔍 [LIQUIDACION] Estructura completa de this.account:', JSON.stringify(this.account, null, 2));
    
    // Para liquidaciones, las validaciones de referencia y banco son más flexibles
    if (isLiquidacion) {
      console.log('✅ [LIQUIDACION] Es liquidación (detectada por account), permitiendo continuar');
      return true; // Permitir continuar con campos básicos
    }
    
    // Para depósitos en efectivo, no requiere cuenta origen
    if (isDepositoEfectivo) {
      console.log('✅ [DEPOSITO] Es depósito en efectivo, permitiendo continuar sin cuenta origen');
      return true; // Permitir continuar con campos básicos
    }
    
    // Si es customer con campos básicos, validar cuenta origen para flujo tradicional
    const hasBasicFields = this.form?.get('total_amount')?.value > 0;
    const hasOriginAccount = this.form?.get('origin_account')?.value;
    
    if (hasBasicFields && isCustomer) {
      if (!hasOriginAccount) {
        console.log('❌ [LIQUIDACION] Customer sin cuenta origen (requerida para flujo tradicional)');
        return false;
      }
      console.log('✅ [LIQUIDACION] Customer con campos básicos Y cuenta origen, permitiendo continuar');
      return true;
    }
    
    // Validación de teléfono para PAGO_MOVIL (quitamos validationMinAmount)
    if (isPagoMovil && !isCustomer && !this.validationPhone) {
      console.log('❌ [LIQUIDACION] Falla validación teléfono PAGO_MOVIL');
      return false;
    }
    
    // Validación de referencia para bancos que no son Zelle
    if (!isZelle && !this.validationReference && !isCustomer) {
      console.log('❌ [LIQUIDACION] Falla validación referencia');
      return false;
    }
    
    console.log('✅ [LIQUIDACION] Validaciones básicas pasadas');
    return true;
  }

  // Método para determinar si el botón "Siguiente" debe estar deshabilitado
  getBtnNextDisabled(): boolean {
    // Cuenta de otro contrato: no se avanza sin marcar «Entiendo»
    if (this.avisoCuenta && !this.avisoConfirmado) return true;
    //console.log('🔍 [BTN] Evaluando estado del botón...');
    
    // Validaciones básicas comunes
    const hasAmount = this.form?.getRawValue()?.total_amount > 0;
    const hasRateError = this.rate_error;
    
    //console.log('🔍 [BTN] hasAmount:', hasAmount, 'hasRateError:', hasRateError);
    
    // Si hay error de tasa, deshabilitar
    if (hasRateError) {
      //console.log('❌ [BTN] Deshabilitado por rate_error');
      return true;
    }
    
    // Si no hay monto, deshabilitar
    if (!hasAmount) {
      //console.log('❌ [BTN] Deshabilitado por falta de monto');
      return true;
    }
    
    // ================================================================================
    // FLUJO BDV: VALIDACIONES SIMPLIFICADAS PERO CON COMPROBANTE OBLIGATORIO
    // ================================================================================
    if (this.account?.workflow === 'workflow_verificacion_bdv' && this.selectView === 1) {
      
      // ================================================================================
      // CASO 1: VERIFICACIÓN INICIAL (matches === null)
      // ================================================================================
      if (this.simplifiedFlow.verification.matches === null) {
        //console.log('🔍 [BTN-BDV] Evaluando flujo BDV inicial...');
        
        // Para BDV necesitamos: fecha, teléfono, monto Y COMPROBANTE
        const hasPhoneCode = this.form.get('code_phone')?.value;
        const hasPhone = this.form.get('phone')?.value;
        const hasComprobante = this.formDataUpload;
        const isCustomer = this.account?.type_customer === 'CUSTOMER';
        const hasValidBDVData = hasAmount && hasPhoneCode && hasPhone;
        
        //console.log('🔍 [BTN-BDV] hasPhoneCode:', hasPhoneCode, 'hasPhone:', hasPhone);
        //console.log('🔍 [BTN-BDV] hasComprobante:', !!hasComprobante, 'isCustomer:', isCustomer);
        //console.log('🔍 [BTN-BDV] hasValidBDVData:', hasValidBDVData);
        
        if (!hasValidBDVData) {
          //console.log('❌ [BTN-BDV] Deshabilitado - Faltan datos para verificación BDV');
          return true;
        }
        
        // COMPROBANTE OBLIGATORIO (excepto para CUSTOMER)
        if (!hasComprobante && !isCustomer) {
          //console.log('❌ [BTN-BDV] Deshabilitado - Falta comprobante obligatorio');
          return true;
        }
        
        //console.log('✅ [BTN-BDV] Habilitado para verificación inicial');
        return false;
      }
      
      // ================================================================================
      // CASO 2: PAGO ÚNICO ENCONTRADO (matches === 'unique')
      // ================================================================================
      if (this.simplifiedFlow.verification.matches === 'unique') {
        //console.log('🔍 [BTN-BDV-UNIQUE] Evaluando flujo BDV con pago único...');
        
        const hasComprobante = this.formDataUpload;
        const isCustomer = this.account?.type_customer === 'CUSTOMER';
        const hasPaymentToken = this.simplifiedFlow.data.paymentToken;
        
        //console.log('🔍 [BTN-BDV-UNIQUE] hasComprobante:', !!hasComprobante, 'isCustomer:', isCustomer);
        //console.log('🔍 [BTN-BDV-UNIQUE] hasPaymentToken:', !!hasPaymentToken);
        
        // COMPROBANTE OPCIONAL en workflow BDV con paymentToken
        //console.log('✅ [BTN-BDV-UNIQUE] Comprobante opcional para workflow BDV');
        
        // Debe tener paymentToken para continuar
        if (!hasPaymentToken) {
          //console.log('❌ [BTN-BDV-UNIQUE] Deshabilitado - Falta paymentToken');
          return true;
        }
        
        console.log('✅ [BTN-BDV-UNIQUE] Habilitado - Pago único listo para confirmar');
        return false;
      }
      
      // ================================================================================
      // CASO 3: MÚLTIPLES PAGOS (matches === 'multiple')
      // ================================================================================
      if (this.simplifiedFlow.verification.matches === 'multiple') {
        //console.log('🔍 [BTN-BDV-MULTIPLE] Evaluando flujo BDV con múltiples pagos...');
        
        const hasReference = this.form.get('reference')?.value;
        const hasPaymentToken = this.simplifiedFlow.data.paymentToken;
        
        //console.log('🔍 [BTN-BDV-MULTIPLE] hasReference:', hasReference);
        //console.log('🔍 [BTN-BDV-MULTIPLE] hasPaymentToken:', !!hasPaymentToken);
        
        // Si NO tiene paymentToken, solo necesita referencia válida para hacer verificación
        if (!hasPaymentToken) {
          if (!hasReference || !this.validationReference) {
            //console.log('❌ [BTN-BDV-MULTIPLE] Deshabilitado - Falta referencia válida para verificar');
            return true;
          }
          //console.log('✅ [BTN-BDV-MULTIPLE] Habilitado - Listo para verificar con referencia');
          return false;
        }
        
        // Si YA tiene paymentToken (verificación exitosa), comprobante opcional
        const hasComprobante = this.formDataUpload;
        const isCustomer = this.account?.type_customer === 'CUSTOMER';
        
        //console.log('🔍 [BTN-BDV-MULTIPLE] hasComprobante:', !!hasComprobante, 'isCustomer:', isCustomer);
        
        // COMPROBANTE OPCIONAL en workflow BDV con paymentToken
        //console.log('✅ [BTN-BDV-MULTIPLE] Comprobante opcional para workflow BDV');
        
        //console.log('✅ [BTN-BDV-MULTIPLE] Habilitado - PaymentToken obtenido, listo para confirmar');
        return false;
      }
      
      // ================================================================================
      // CASO 4: SIN PAGOS ENCONTRADOS (matches === 'none')
      // ================================================================================
      if (this.simplifiedFlow.verification.matches === 'none') {
        //console.log('🔍 [BTN-BDV-NONE] Sin pagos encontrados, usar validación tradicional...');
        // Continúa al flujo tradicional abajo
      }
    }
    
    // ================================================================================
    // FLUJO TRADICIONAL: VALIDACIONES COMPLETAS
    // ================================================================================
    //console.log('🔍 [BTN] Evaluando flujo tradicional...');
    
    const isCustomer = this.account?.type_customer === 'CUSTOMER';
    const isPagoMovil = this.account?.payment_method?.code === 'PAGO_MOVIL';
    const isZelle = this.account?.bank?.name === 'Zelle';
    const isLiquidacion = this.account && (
      this.account.bank?.name?.toLowerCase().includes('liquidacion') || 
      this.account.bank?.name?.toLowerCase().includes('liquidación') ||
      this.account.bank?.description?.toLowerCase().includes('liquidacion') ||
      this.account.bank?.description?.toLowerCase().includes('liquidación') ||
      this.account.number?.toLowerCase().includes('liquidacion') ||
      this.account.number?.toLowerCase().includes('liquidación')
    );
    
    // VALIDACIÓN DE CUENTA ORIGEN para flujo tradicional (EXCEPTO LIQUIDACIONES Y DEPÓSITOS EN EFECTIVO)
    const isDepositoEfectivo = this.account?.payment_method?.code === 'DEPOSITO_BS';
    const hasOriginAccount = this.form?.get('origin_account')?.value;
    if (!isLiquidacion && !isDepositoEfectivo && !hasOriginAccount) {
      //console.log('❌ [BTN] Deshabilitado - Falta cuenta origen para flujo tradicional');
      return true;
    }
    
    // Validación de teléfono para PAGO_MOVIL (quitamos validationMinAmount)
    if (isPagoMovil && !isCustomer && !this.validationPhone) {
      //console.log('❌ [BTN] Deshabilitado - Validación teléfono PAGO_MOVIL');
      return true;
    }
    
    // Validación de referencia para bancos que no son Zelle (EXCEPTO LIQUIDACIONES)
    if (!isZelle && !this.validationReference && !isCustomer && !isLiquidacion) {
      //console.log('❌ [BTN] Deshabilitado - Validación referencia');
      return true;
    }
    
    // COMPROBANTE OBLIGATORIO para no-customer y no-edit (IGUAL QUE EN BDV)
    if (!this.formDataUpload && !isCustomer && !this.paymentEdit) {
      //console.log('❌ [BTN] Deshabilitado - Falta comprobante obligatorio (flujo tradicional)');
      return true;
    }
    
    //console.log('✅ [BTN] Habilitado para flujo tradicional');
    return false;
  }

  // Método para determinar si el botón "Confirmar Pago" debe estar deshabilitado
  getBtnConfirmDisabled(): boolean {
    // Cuenta de otro contrato: no se avanza sin marcar «Entiendo»
    if (this.avisoCuenta && !this.avisoConfirmado) return true;
    //console.log('🔍 [BTN-CONFIRM] Evaluando estado del botón Confirmar...');
    
    // Validaciones básicas comunes
    const hasAmount = this.form?.getRawValue()?.total_amount > 0;
    const hasRateError = this.rate_error;
    
    //console.log('🔍 [BTN-CONFIRM] hasAmount:', hasAmount, 'hasRateError:', hasRateError);
    
    // Si hay error de tasa, deshabilitar
    if (hasRateError) {
      //console.log('❌ [BTN-CONFIRM] Deshabilitado por rate_error');
      return true;
    }
    
    // Si no hay monto, deshabilitar
    if (!hasAmount) {
      //console.log('❌ [BTN-CONFIRM] Deshabilitado por falta de monto');
      return true;
    }
    
    // ================================================================================
    // FLUJO BDV CON PAYMENT TOKEN: COMPROBANTE OPCIONAL
    // ================================================================================
    if (this.account?.workflow === 'workflow_verificacion_bdv' && 
        this.simplifiedFlow.verification.matches === 'unique' && 
        this.simplifiedFlow.data.paymentToken) {
      
      //console.log('🔍 [BTN-CONFIRM-BDV] Evaluando flujo BDV con paymentToken...');
      
      const hasComprobante = this.formDataUpload;
      const isCustomer = this.account?.type_customer === 'CUSTOMER';
      
      //console.log('🔍 [BTN-CONFIRM-BDV] hasComprobante:', !!hasComprobante, 'isCustomer:', isCustomer);
      //console.log('🔍 [BTN-CONFIRM-BDV] paymentToken:', !!this.simplifiedFlow.data.paymentToken);
      
      // COMPROBANTE OPCIONAL para workflow BDV con paymentToken
      //console.log('✅ [BTN-CONFIRM-BDV] Comprobante opcional para workflow BDV');
      
      //console.log('✅ [BTN-CONFIRM-BDV] Habilitado - PaymentToken disponible');
      return false;
    }
    
    // ================================================================================
    // FLUJO BDV SIN PAYMENT TOKEN: COMPROBANTE OBLIGATORIO
    // ================================================================================
    if (this.account?.workflow === 'workflow_verificacion_bdv' && 
        this.simplifiedFlow.verification.matches === 'none') {
      
      //console.log('🔍 [BTN-CONFIRM-BDV-NONE] Evaluando flujo BDV sin pago encontrado...');
      
      const hasComprobante = this.formDataUpload;
      const isCustomer = this.account?.type_customer === 'CUSTOMER';
      
      //console.log('🔍 [BTN-CONFIRM-BDV-NONE] hasComprobante:', !!hasComprobante, 'isCustomer:', isCustomer);
      
      // COMPROBANTE OBLIGATORIO cuando no se encontró pago automáticamente
      if (!hasComprobante && !isCustomer) {
        //console.log('❌ [BTN-CONFIRM-BDV-NONE] Deshabilitado - Comprobante obligatorio cuando no hay pago detectado');
        return true;
      }
      
      //console.log('✅ [BTN-CONFIRM-BDV-NONE] Habilitado - Comprobante presente para procesamiento manual');
      return false;
    }
    
    // ================================================================================
    // FLUJO TRADICIONAL: VALIDACIONES COMPLETAS (IGUAL QUE ANTES)
    // ================================================================================
    //console.log('🔍 [BTN-CONFIRM] Evaluando flujo tradicional...');
    
    const isCustomer = this.account?.type_customer === 'CUSTOMER';
    const isPagoMovil = this.account?.payment_method?.code === 'PAGO_MOVIL';
    const isZelle = this.account?.bank?.name === 'Zelle';
    
  // Validación de teléfono para PAGO_MOVIL (quitamos validationMinAmount)
  if (isPagoMovil && !isCustomer && !this.validationPhone) {
      //console.log('❌ [BTN-CONFIRM] Deshabilitado - Validación teléfono PAGO_MOVIL');
      return true;
    }
    
    // Validación de referencia para bancos que no son Zelle
    if (!isZelle && !this.validationReference && !isCustomer) {
      //console.log('❌ [BTN-CONFIRM] Deshabilitado - Validación referencia');
      return true;
    }
    
    // COMPROBANTE OBLIGATORIO para no-customer y no-edit
    if (!this.formDataUpload && !isCustomer && !this.paymentEdit) {
      //console.log('❌ [BTN-CONFIRM] Deshabilitado - Falta comprobante obligatorio (flujo tradicional)');
      return true;
    }
    
    //console.log('✅ [BTN-CONFIRM] Habilitado para flujo tradicional');
    return false;
  }

  async nextStep() {
    
    console.log('🚀 [LIQUIDACION] nextStep llamado - selectView:', this.selectView, 'selectMaxView:', this.selectMaxView);
    console.log('🚀 [LIQUIDACION] Estado del formulario:', {
      formValid: this.form.valid,
      account: !!this.account,
      typeProduct: this.typeProduct,
      confirmLoading: this.confirmLoading,
      confirm: this.confirm
    });
    console.log('🔍 [LIQUIDACION] Verificando typeProduct:', {
      typeProduct_value: this.typeProduct,
      typeProduct_length: this.typeProduct?.length,
      inputValue: this.inputValue,
      productArray: this.productArray?.length
    });

    if (this.selectView < this.selectMaxView) {
      // ================================================================================
      // FLUJO BDV: VERIFICACIÓN EN EL PRIMER PASO
      // ================================================================================
      if (this.account?.workflow === 'workflow_verificacion_bdv' && 
          this.selectView === 1 && 
          this.simplifiedFlow.verification.matches === null) {
        
        
        // Validar que los campos requeridos estén llenos
        if (!this.form.get('total_amount')?.value || 
            !this.form.get('code_phone')?.value || 
            !this.form.get('phone')?.value) {
          this.form.markAllAsTouched();
          return;
        }

        // Ejecutar verificación BDV
        await this.verifyPaymentBDV();
        
        // Después de la verificación, no avanzar automáticamente
        // El usuario tendrá que hacer click en "Siguiente" otra vez
        return;
      }

      // ================================================================================
      // FLUJO BDV: MÚLTIPLES PAGOS - VERIFICAR CON REFERENCIA
      // ================================================================================
      if (this.account?.workflow === 'workflow_verificacion_bdv' && 
          this.selectView === 1 && 
          this.simplifiedFlow.verification.matches === 'multiple' &&
          !this.simplifiedFlow.data.paymentToken) {
        
        
        // Validar que la referencia esté presente
        const reference = this.form.get('reference')?.value;
        if (!reference) {
          this.form.get('reference')?.markAsTouched();
          alertifyjs.error('Por favor ingresa la referencia.');
          return;
        }

        // Ejecutar confirmación con referencia
        await this.confirmPaymentBDVWithReference();
        
        // No avanzar automáticamente - el resultado determinará el siguiente paso
        return;
      }

      // ================================================================================
      // FLUJO BDV: SIN PAGOS ENCONTRADOS - VALIDAR COMPROBANTE OBLIGATORIO
      // ================================================================================
      if (this.account?.workflow === 'workflow_verificacion_bdv' && 
          this.selectView === 1 && 
          this.simplifiedFlow.verification.matches === 'none') {
        
        
        const hasComprobante = this.formDataUpload;
        const isCustomer = this.account?.type_customer === 'CUSTOMER';
        
        
        // COMPROBANTE OBLIGATORIO cuando no se encontró pago automáticamente
        if (!hasComprobante && !isCustomer) {
          alertifyjs.error('No se encontraron pagos automáticamente. Por favor, adjunta el comprobante de pago para continuar.');
          return;
        }
        
        // Continúa al flujo normal abajo
      }

      // ================================================================================
      // FLUJO NORMAL: AVANZAR AL SIGUIENTE PASO
      // ================================================================================
      
      // Validación mejorada para flujo tradicional
      const isLiquidacion = this.typeProduct && (this.typeProduct.toLowerCase().includes('liquidacion') || this.typeProduct.toLowerCase().includes('liquidación'));
      const isCustomer = this.account?.type_customer === 'CUSTOMER';
      const hasAmount = this.form?.getRawValue()?.total_amount > 0;
      const hasRequiredFields = this.validateRequiredFieldsForTraditionalFlow();
      
      if (hasAmount && hasRequiredFields && this.account && !this.rate_error) {
        this.selectView = this.selectView + 1;
      } else {
        // Marcar todos los campos como touched para mostrar errores de validación
        Object.keys(this.form.controls).forEach(key => {
          this.form.get(key)?.markAsTouched();
          this.form.get(key)?.markAsDirty();
        });
        
        if (this.rate_error) {
          alertifyjs.error('Error en la tasa de cambio. Por favor, intente nuevamente.');
        } else if (!hasAmount) {
          alertifyjs.error('Por favor, ingrese un monto válido mayor a 0');
        } else if (!this.account) {
          alertifyjs.error('Por favor, seleccione una cuenta de pago');
        } else {
          alertifyjs.error('Por favor, complete todos los campos requeridos');
        }
      }

    } else if (this.confirm) {
      console.log('🔄 [LIQUIDACION] Redirecting porque confirm=true');
      this.redirectTo();

    } else {

      console.log('🎯 [LIQUIDACION] Entrando en fase de confirmación de pago');
      console.log('🎯 [LIQUIDACION] Workflow:', this.account?.workflow);
      console.log('🎯 [LIQUIDACION] PaymentToken:', !!this.simplifiedFlow.data.paymentToken);

      // ================================================================================
      // FLUJO BDV: VALIDACIÓN ESPECIAL PARA CONFIRMAR PAGO CON PAYMENT TOKEN
      // ================================================================================
      if (this.account?.workflow === 'workflow_verificacion_bdv' && 
          this.simplifiedFlow.data.paymentToken) {
        
        console.log('🔍 [LIQUIDACION] Flujo BDV con paymentToken');
        
        // En el flujo BDV con paymentToken, solo validamos campos esenciales
        const hasAmount = this.form?.get('total_amount')?.value > 0;
        const hasPhoneCode = this.form.get('code_phone')?.value;
        const hasPhone = this.form.get('phone')?.value;
        
        console.log('🔍 [LIQUIDACION] Validaciones BDV:', { hasAmount, hasPhoneCode, hasPhone, account: !!this.account });
        
        if (hasAmount && hasPhoneCode && hasPhone && this.account) {
          console.log('✅ [LIQUIDACION] Validaciones BDV pasadas, ejecutando registro...');
          if (this.paymentEdit) {
            this.setUpdateOrder();
          } else {
            this.setNewOrder();
          }
        } else {
          console.log('❌ [LIQUIDACION] Validaciones BDV fallaron');
          alertifyjs.error('Por favor, complete todos los campos requeridos');
        }
        
      } else {
        // ================================================================================
        // FLUJO TRADICIONAL: VALIDACIÓN COMPLETA
        // ================================================================================
        console.log('🔍 [LIQUIDACION] Flujo tradicional');
        console.log('🔍 [LIQUIDACION] Form valid:', this.form.valid, 'Account:', !!this.account);
        console.log('🔍 [LIQUIDACION] Form errors:', this.form.errors);
        
    // Validación mejorada para liquidaciones y depósitos en efectivo - basada en account_payment
    const isLiquidacion = this.account && (
      this.account.bank?.name?.toLowerCase().includes('liquidacion') || 
      this.account.bank?.name?.toLowerCase().includes('liquidación') ||
      this.account.bank?.description?.toLowerCase().includes('liquidacion') ||
      this.account.bank?.description?.toLowerCase().includes('liquidación') ||
      this.account.number?.toLowerCase().includes('liquidacion') ||
      this.account.number?.toLowerCase().includes('liquidación')
    );
    const isDepositoEfectivo = this.account?.payment_method?.code === 'DEPOSITO_BS';
        const hasBasicRequiredFields = this.validateRequiredFieldsForTraditionalFlow();
        const hasAmount = this.form?.getRawValue()?.total_amount > 0;
        const isCustomer = this.account?.type_customer === 'CUSTOMER';
        
        // Permitir continuar si es liquidación, depósito en efectivo, o customer con campos básicos
        const canContinueAsLiquidacion = (isLiquidacion || isDepositoEfectivo || isCustomer) && hasAmount && hasBasicRequiredFields;
        
        console.log('🔍 [LIQUIDACION] Validación mejorada:', {
          isLiquidacion,
          isDepositoEfectivo,
          hasBasicRequiredFields, 
          hasAmount,
          isCustomer,
          canContinueAsLiquidacion,
          formValid: this.form.valid
        });
        
        if ((this.form.valid || canContinueAsLiquidacion) && this.account) {
          console.log('✅ [LIQUIDACION] Validaciones tradicionales pasadas, ejecutando registro...');
          if (this.paymentEdit) {
            this.setUpdateOrder();
          } else {
            this.setNewOrder();
          }
        } else {
          console.log('❌ [LIQUIDACION] Validaciones tradicionales fallaron');
          console.log('❌ [LIQUIDACION] Form controls errors:');
          Object.keys(this.form.controls).forEach(key => {
            const control = this.form.get(key);
            if (control?.errors) {
              console.log(`   - ${key}:`, control.errors);
            }
            control?.markAsTouched();
            control?.markAsDirty();
          });
          
          if (canContinueAsLiquidacion || isLiquidacion) {
            alertifyjs.error('Por favor, complete los campos básicos requeridos para liquidación');
          } else {
          alertifyjs.error('Por favor, complete todos los campos requeridos');
          }
        }
      }
    }
  }


  redirectTo() {
    this.router.navigate([`/console/payments/person/${this.person?.person?.code}`], {});
  }

  backStep() {

    if (this.selectView > 1) {

      this.selectView = this.selectView - 1;

    }
  }


  equal(a: number, b: number) {
    const m = a == this.selectMaxView;
    return m;
  }

  detectBrowser() {
    var userAgent = navigator.userAgent;
    if (userAgent.indexOf("Chrome") > -1) {
        return "Chrome";
    } else if (userAgent.indexOf("Safari") > -1) {
        return "Safari";
    } else if (userAgent.indexOf("Firefox") > -1) {
        return "Firefox";
    } else if (userAgent.indexOf("MSIE") > -1 || userAgent.indexOf("Trident") > -1) {
        return "Internet Explorer";
    } else if (userAgent.indexOf("Edge") > -1) {
        return "Edge";
    } else {
        return "Unknown";
    }
}


  getDeviceInfo() {
    const userAgent = this.detectBrowser();
    const platform = navigator.platform;
    const version = navigator.appVersion;

    let platform_text = platform.split(" ");

    return {
      userAgent,
      platform: platform_text[0],
      version
    };
  }


  setNewOrder = async () => {
    console.log('🚀 [LIQUIDACION] ¡setNewOrder ejecutado! Iniciando registro de pago...');
    let info = this.getDeviceInfo();
    let client_identify: any = {
      ipaddress: "",
      browser_agent: info?.userAgent ?? "",
      mobile: {
        manufacturer: "",
        model: "",
        os_version: info?.platform ?? "",
        location: {
          lat: this.latitude,
          lng: this.longitude,
        },
      },
    };

    console.log(client_identify);
    console.log('🔍 [LIQUIDACION] client_identify creado correctamente');
    
    // Validación especial para flujo BDV con paymentToken
    const isBDVWithToken = this.account?.workflow === 'workflow_verificacion_bdv' && 
                          this.simplifiedFlow.data.paymentToken;
    const isFormValidForBDV = isBDVWithToken && 
                             this.form?.get('total_amount')?.value > 0 &&
                             this.form.get('code_phone')?.value &&
                             this.form.get('phone')?.value;
    
    // Validación especial para liquidaciones y depósitos en efectivo - basada en account_payment
    const isLiquidacion = this.account && (
      this.account.bank?.name?.toLowerCase().includes('liquidacion') || 
      this.account.bank?.name?.toLowerCase().includes('liquidación') ||
      this.account.bank?.description?.toLowerCase().includes('liquidacion') ||
      this.account.bank?.description?.toLowerCase().includes('liquidación') ||
      this.account.number?.toLowerCase().includes('liquidacion') ||
      this.account.number?.toLowerCase().includes('liquidación')
    );
    const isDepositoEfectivo = this.account?.payment_method?.code === 'DEPOSITO_BS';
    const hasBasicRequiredFields = this.validateRequiredFieldsForTraditionalFlow();
    const hasAmount = this.form?.getRawValue()?.total_amount > 0;
    const isCustomer = this.account?.type_customer === 'CUSTOMER';
    const isFormValidForLiquidacion = (isLiquidacion || isDepositoEfectivo || isCustomer) && hasAmount && hasBasicRequiredFields;
    
    console.log('🔍 [LIQUIDACION] Validaciones en setNewOrder:', {
      formValid: this.form.valid,
      isFormValidForBDV,
      isFormValidForLiquidacion,
      isLiquidacion,
      isDepositoEfectivo,
      hasBasicRequiredFields,
      hasAmount,
      isCustomer,
      canContinue: this.form.valid || isFormValidForBDV || isFormValidForLiquidacion
    });
    console.log('🔍 [LIQUIDACION] Account en setNewOrder:', JSON.stringify(this.account, null, 2));
    
    if (this.form.valid || isFormValidForBDV || isFormValidForLiquidacion) {

    this.confirmLoading = true;

    try {
      console.log('🔍 [LIQUIDACION] Entrando en try block...');

      const form = this.form.getRawValue();
      console.log('🔍 [LIQUIDACION] Form getRawValue() completado:', form);


       const {
        description,
        payment_method,
        reference,
        code_identity,
        identity,
        total_amount,
        phone,
        origin_account,
        code_phone,
        accountNumber

      }  = form;
      
      console.log('🔍 [LIQUIDACION] Destructuring completado exitosamente');

      const formData = new FormData();

      if (this.formDataUpload) {

         formData.append("archivo", this.formDataUpload);

     }


     let code = this.person?.person?.code;


     let deductions_payment:any = {};
     let fees: any = [];

     let account = this.account;

     this.deduction_payment.forEach((v:any, key:any) => {
        if((v?.currency?.code == account?.currency?.code) || !v?.currency ){
          if(v.isPorcent){
            let resp = v?.amount || 0;
            let porcent = this.toFixedApp(this.toFixedApp((total_amount * resp) / 100));
              deductions_payment[v._id] = porcent;
          }
        }

     });
     // fee
     if(this.concept_deduction_apply) {
        fees =  this.concept_deduction_apply.map((row:any)=>{
          return {fee: row?.fee?._id, installment: row?._id}
        });
     }


    if(!this.multipago){

       // Construir el objeto params base con manejo especial para liquidaciones
       const isLiquidacion = this.account && (
         this.account.name?.toLowerCase().includes('liquidacion') || 
         this.account.name?.toLowerCase().includes('liquidación') ||
         this.account.description?.toLowerCase().includes('liquidacion') ||
         this.account.description?.toLowerCase().includes('liquidación')
       );
       
       console.log('🔍 [LIQUIDACION] Datos del formulario:', {
         typeProduct: this.typeProduct,
         isLiquidacion,
         reference_original: reference,
         origin_account,
         accountNumber,
         description,
         payment_method,
         total_amount,
         code_identity,
         identity,
         phone,
         code_phone
       });
       
       const processedReference = isLiquidacion && (!reference || reference.trim() === '') ? `LIQ-${Date.now().toString().slice(-6)}` : reference;
       
       const paramsObject: any = {
        currency:this.account?.currency?.code,
        description,
        payment_method,
        reference: processedReference,
        cid:`${code_identity}${identity}`,
        total_amount,
        code_person: code,
        code_account_payment : this.account_payment,
        code_installment:this.installment?.code,
        date_register:this.date_base_string,
        deductions_payment: deductions_payment,
        fees: fees,
        phone:`${code_phone}${phone}`,
        bankCode: isLiquidacion ? (origin_account || '') : origin_account,
        accountNumber: isLiquidacion ? (accountNumber || '') : accountNumber,
        client_identify,
        typeProduct:this.typeProduct
       };
       
       console.log('📤 [LIQUIDACION] Objeto final enviado al backend:', paramsObject);
       console.log('🔍 [LIQUIDACION] Campos que podrían estar problemáticos:', {
         reference_procesada: processedReference,
         bankCode: paramsObject.bankCode,
         accountNumber: paramsObject.accountNumber,
         cid: paramsObject.cid,
         phone: paramsObject.phone
       });

       // AGREGAR PAYMENT TOKEN SI ESTÁ DISPONIBLE (FLUJO BDV UNIQUE)
       if (this.simplifiedFlow.data.paymentToken && 
           this.account?.workflow === 'workflow_verificacion_bdv' && 
           this.simplifiedFlow.verification.matches === 'unique') {
         paramsObject.paymentToken = this.simplifiedFlow.data.paymentToken;
         console.log('[BDV] 🎯 Agregando paymentToken al registro:', this.simplifiedFlow.data.paymentToken);
       }

       formData.append("params", JSON.stringify(paramsObject));


    }else{

      // Construir el objeto params para multipago con manejo especial para liquidaciones
      const isLiquidacion = this.typeProduct && (this.typeProduct.toLowerCase().includes('liquidacion') || this.typeProduct.toLowerCase().includes('liquidación'));
      
      console.log('🔍 [LIQUIDACION-MULTIPAGO] Datos del formulario:', {
        typeProduct: this.typeProduct,
        isLiquidacion,
        reference_original: reference,
        origin_account,
        accountNumber
      });
      
      const processedReference = isLiquidacion && (!reference || reference.trim() === '') ? `LIQ-${Date.now().toString().slice(-6)}` : reference;
      
      const multipagoParamsObject: any = {
        currency:this.account?.currency?.code,
        description,
        payment_method,
        reference: processedReference,
        cid:`${code_identity}${identity}`,
        total_amount,
        code_person: code,
        code_account_payment : this.account_payment,
        date_register:this.date_base_string,
        deductions_payment: deductions_payment,
        fees: fees,
        phone:`${code_phone}${phone}`,
        bankCode: isLiquidacion ? (origin_account || '') : origin_account,
        accountNumber: isLiquidacion ? (accountNumber || '') : accountNumber,
        client_identify,
        typeProduct:this.typeProduct
      };
      
      console.log('📤 [LIQUIDACION-MULTIPAGO] Objeto final enviado al backend:', multipagoParamsObject);

      // AGREGAR PAYMENT TOKEN SI ESTÁ DISPONIBLE (FLUJO BDV UNIQUE - MULTIPAGO)
      if (this.simplifiedFlow.data.paymentToken && 
          this.account?.workflow === 'workflow_verificacion_bdv' && 
          this.simplifiedFlow.verification.matches === 'unique') {
        multipagoParamsObject.paymentToken = this.simplifiedFlow.data.paymentToken;
        console.log('[BDV] 🎯 Agregando paymentToken al registro multipago:', this.simplifiedFlow.data.paymentToken);
      }

      formData.append("params", JSON.stringify(multipagoParamsObject));

    }

      //throw new Error("");



      let resp = await this._user.getRegister_payment(formData);

       this.responseTransaction = resp;

       if(this.responseTransaction?.status == 'A'){
         this.confirm = true;
       }

       this.confirmLoading = false;
       this.selectView = 4;


    } catch (error:any) {

      console.error('❌ [LIQUIDACION] Error en setNewOrder:', error);
      console.error('❌ [LIQUIDACION] Detalles del error:', {
        status: error.status,
        error: error.error,
        message: error.message,
        stack: error.stack
      });

      if(error.status == 400 && error?.error?.control){

        this.responseTransaction = error?.error;
        this.selectView = 4;


      }else{

        if(error?.error?.code == 52){
          console.error('❌ [LIQUIDACION] Error código 52:', error?.error?.msg);
          alertifyjs.error(error?.error?.msg);
          this.selectView = 1;

        }else{

          console.error('❌ [LIQUIDACION] Error interno no identificado:', error);
          alertifyjs.error(`Error interno, vuelva a cargar el pago`);

        }


      // alertifyjs.error(`Error al crear solicitud `);

      }

      this.confirmLoading = false;

    }

  }

  }

  setUpdateOrder = async () => {

    // Validación mejorada para liquidaciones y depósitos en efectivo - igual que en nextStep()
    const isLiquidacion = this.account && (
      this.account.bank?.name?.toLowerCase().includes('liquidacion') || 
      this.account.bank?.name?.toLowerCase().includes('liquidación') ||
      this.account.bank?.description?.toLowerCase().includes('liquidacion') ||
      this.account.bank?.description?.toLowerCase().includes('liquidación') ||
      this.account.number?.toLowerCase().includes('liquidacion') ||
      this.account.number?.toLowerCase().includes('liquidación')
    );
    const isDepositoEfectivo = this.account?.payment_method?.code === 'DEPOSITO_BS';
    const hasBasicRequiredFields = this.validateRequiredFieldsForTraditionalFlow();
    const hasAmount = this.form?.getRawValue()?.total_amount > 0;
    const isCustomer = this.account?.type_customer === 'CUSTOMER';
    
    // Permitir continuar si es liquidación, depósito en efectivo, o customer con campos básicos
    const canContinueAsLiquidacion = (isLiquidacion || isDepositoEfectivo || isCustomer) && hasAmount && hasBasicRequiredFields;

    console.log('🔍 [UPDATE_ORDER] Validación para actualización:', {
      isLiquidacion,
      isDepositoEfectivo,
      hasBasicRequiredFields, 
      hasAmount,
      isCustomer,
      canContinueAsLiquidacion,
      formValid: this.form.valid
    });

    if (this.form.valid || canContinueAsLiquidacion) {

    this.confirmLoading = true;

    try {


      const form = this.form.getRawValue();


       const {
        description,
        payment_method,
        reference,
        code_identity,
        identity,
        total_amount,
        phone,
        origin_account,
        code_phone,
        accountNumber

      }  = form;

      const formData = new FormData();

      if (this.formDataUpload) {

         formData.append("archivo", this.formDataUpload);

     }


     let code = this.person?.person?.code;


     let deductions_payment:any = {};

     let account = this.account;

    this.deduction_payment.forEach((v:any, key:any) => {


      if((v?.currency?.code == account?.currency?.code) || !v?.currency ){
        if(v.isPorcent){
          let resp = v?.amount || 0;


           let porcent = this.toFixedApp(this.toFixedApp((total_amount * resp) / 100));

            deductions_payment[v._id] = porcent;
        }
      }

  });
  debugger

       formData.append("params", JSON.stringify({
        currency:this.account?.currency?.code,
        description,
        payment_method,
        reference,
        cid:`${code_identity}${identity}`,
        total_amount,
        code_person: code,
        code_account_payment : this.account_payment,
        code_installment:this.installment?.code,
        date_register:this.date_base_string,
        deductions_payment: deductions_payment,
        phone:`${code_phone}${phone}`,
        bankCode:origin_account,
        accountNumber,
        code_payment:this.paymentEdit?.payment?.code || null,
        description_edit: this.paymentEdit?.description_edit,
        fee_delete: this.fee_delete


      }));

    //  throw new Error("");




     let resp = await this._user.getUpdate_payment(formData);


     this.responseTransaction = resp?.resp;

        this.confirmLoading = false;
        this.redirectTo();


    } catch (error:any) {


      if(error.status == 400 && error?.error?.control){

        this.responseTransaction = error?.error;
        this.redirectTo();


      }else{

        if(error?.error?.code == 52){
          alertifyjs.error(error?.error?.msg);
          this.selectView = 1;

        }else{

          alertifyjs.error(`Error interno, vuelva a cargar el pago`);

        }


      // alertifyjs.error(`Error al crear solicitud `);

      }

      this.confirmLoading = false;

    }

  }

  }

  updateValueCurrency(value: any) {

    return this.currencyPipe.transform(value, 'USD', '', '1.2-2');
}




onFileSelected  = async  (event:any) => {
  const file:File = event.target.files[0];
/*
  const fileSizeInBytes = file.size;
  const fileSizeInMB = fileSizeInBytes / (1024 * 1024);

  console.log(`El tamaño del archivo es de ${fileSizeInMB.toFixed(2)} MB`);
*/

  if (file) {
      this.fileName = file.name;
      this.formDataUpload = file;

     /* const formData = new FormData();

      formData.append("archivo", file);

      formData.append("params", JSON.stringify({
         nombre:"juan soto"
      })


    );*/
     // const resp = await this._LaService.setUpload(formData);

  }


}



getIdentity(item: any) {

  if (!(item?.identitys?.length > 0))
    return "";

  return `${item?.identitys[0]?.type_identity?.name} ${item?.identitys[0]?.code_identity?.name}-${item?.identitys[0]?.identity}`;

}


getContact(item: any) {

  if (!(item?.constacts?.length > 0))
    return "";

  return `${item?.constacts[0]?.contact}`;

}

  getEmailContact(item: any) {
    if (!(item?.constacts?.length > 1) || !item?.constacts[1]) return '';

    return `${item?.constacts[1]?.contact}`;
  }

  // Función para extraer solo el número de cédula
  getIdentityNumber(item: any): string {
    if (!(item?.identitys?.length > 0)) return "";
    return item?.identitys[0]?.identity || "";
  }

  // Función para extraer solo el número de teléfono sin +58
  getPhoneNumber(item: any): string {
    if (!(item?.constacts?.length > 0)) return "";
    let contact = item?.constacts[0]?.contact || "";
    // Remover +58 si está presente
    return contact.replace(/^\+58/, "");
  }

  // Función para copiar cédula al portapapeles
  copyIdentityToClipboard(item: any) {
    const identity = this.getIdentityNumber(item);
    if (identity) {
      navigator.clipboard.writeText(identity).then(() => {
        alertifyjs.success('Cédula copiada al portapapeles');
      }).catch(err => {
        console.error('Error al copiar al portapapeles: ', err);
        alertifyjs.error('Error al copiar al portapapeles');
      });
    }
  }

  // Función para copiar teléfono al portapapeles
  copyPhoneToClipboard(item: any) {
    const phone = this.getPhoneNumber(item);
    if (phone) {
      navigator.clipboard.writeText(phone).then(() => {
        alertifyjs.success('Número copiado al portapapeles');
      }).catch(err => {
        console.error('Error al copiar al portapapeles: ', err);
        alertifyjs.error('Error al copiar al portapapeles');
      });
    }
  }


  sanitize(url: string) {
  //return url;
  return this.sanitizer.bypassSecurityTrustUrl(url);
}


getPersonInstallmentsInvoiceCredits = async (invoice:any) => {
  this.loading = true;
  try {
       const data =  {
        code_invoice:invoice

       }

     const  installments  = await this._user.getPersonInstallmentsInvoiceCredits(data);

     installments?.res?.map((value:any, index:any) => {

      if(value?.installMent?.code == this.installmentParams){

        this.installment = value?.installMent;
        this.dueBalance =  this.toFixedApp(value?.installMent?.invoice?.dueBalance);
        this.dueBalanceCurrecy = this.dueBalance;

        this.payments = value?.payments;
        this.paymentsReference = value?.paymentReference;

      }



      return value;
    });


    if(!this.installment){
      this.router.navigate(['/'], {});

    }



  let remanente_resp =  await this._user.getRemanentInvoice({
    "invoiceCode": invoice,
    "status": true
   })


   let remanente: any;
   remanente_resp?.map((value2:any)=>{

     remanente = {};

      remanente['payment_status_remante'] = true;
      remanente['remaining_amount'] =  value2?.remaining_amount;
      remanente['total_amount_next_installment'] =  value2?.total_amount_next_installment;
    });

  this.remanente = remanente;

  if(remanente){
    this.installment.dueBalance = remanente.total_amount_next_installment;

  }


    this.getPerson(this.installment?.invoice?.customer?.code);

    this.paymentsReference?.map((value:any, index:any) => {

      this.totalpaymentReference = this.totalpaymentReference + value?.payment?.amount;
      return value;

    });


    this.amountFB =  this.toFixedApp((this.installment?.dueBalance - this.totalpaymentReference)) ;
    this.amountFB_bs  = this.toFixedApp(this.amountFB * this.rate.amount)
    this.amountF =  0 ;

    } catch (error) {
      console.error(error);
     // this.router.navigate(['/'], {});

    }

    this.loading = false;

}

changeMount(){
  let value = this.toFixedApp(this.form?.getRawValue()?.total_amount) ;

  this.setAmount();

  let f = this.amountFB;

  let account = this.account;

  this.dueBalanceCurrecy = this.toFixedApp(this.toFixedApp(this.dueBalance) +  this.toFixedApp(10));


  if(account?.currency?.code == "BS"){


    this.dueBalanceCurrecy = this.toFixedApp(this.toFixedApp(this.toFixedApp(this.dueBalance) +  this.toFixedApp(10)) * this.toFixedApp(this.rate.amount));


      f  = this.toFixedApp(this.amountFB * this.rate.amount);
      this.amountFB_bs  = this.toFixedApp(this.amountFB * this.rate.amount);

  }


  this.amountF =   this.toFixedApp(f - (value || 0)) ;



/*
  this.dueBalance = (this.installment.dueBalance - value) < 0? 0 :  (this.installment.dueBalance - value) ;
  this.amount = (this.installment.amount + value) > this.installment.amount ? this.installment.amount :  (this.installment.amount + value) ;

*/

}

rateConverte(){

  let value = this.form?.getRawValue()?.total_amount;
  if(this.account?.currency?.code == "BS"){

   this.toFixedApp(value = value / this.rate?.amount) ;

  }

  return value;

}



openview(content: TemplateRef<any>) {

  this.offcanvasService.open(content, { position: 'start', keyboard: false });

}

getAccountPayment = async () =>  {
  console.log('=== getAccountPayment called ===');
  this.accountPayment_load = true;

  try {
    let resp =  await this._user.account_payment({ perfil_activo: 1 }); // perfil_activo: aviso de cuenta de otro contrato
    console.log('account_payment response:', resp);

    // Por defecto, las de la empresa del switch y primero en la lista (Mario, 30-oct); los chips muestran las otras
    this.empresaFiltro = empresaActiva(resp?.res);
    this.accountPayment = activasPrimero(resp?.res, this.empresaFiltro);
    this.filteredAccounts = [...(this.accountPayment || [])];
    console.log('Accounts loaded:', this.accountPayment?.length || 0);
    this.accountPayment_load = false;

  } catch (error) {
    console.error('Error loading accounts:', error);
    this.accountPayment_load = false;
    this.filteredAccounts = [];
  }

}


async selectAccount(account:any){
  this.avisoConfirmado = false;

  this.account_payment = account?.code;
  this.account = account;


  console.log('AQUIII');
  console.log(this.account);

  if(this.account.reference_length) {
    console.log(1);
    this.reference_length_max = this.account.reference_length;
    this.reference_length = this.account.reference_length;
  } else {
    console.log(2);
    this.reference_length = this.reference_default_length;
    this.reference_length_max = this.reference_default_length;

  }

  this.validateReferenceLength()

  // ================================================================================
  // DETECCIÓN FLUJO SIMPLIFICADO BDV
  // ================================================================================
  await this.checkBDVWorkflow();

  // ================================================================================
  // INICIALIZACIÓN OPCIÓN DE TELÉFONO
  // ================================================================================
  if (this.account?.payment_method?.code === 'PAGO_MOVIL' && this.person?.person?.phone) {
    // Si hay un teléfono registrado, usar por defecto Y CARGAR EN FORMULARIO
    this.phoneOption = 'default';
    console.log('📱 [INIT] Inicializando con teléfono por defecto...');
    setTimeout(() => {
      this.setPhoneOption('default');
      // GARANTIZAR que los campos se llenen en el formulario
      this.ensurePhoneFieldsAreFilled();
    }, 100);
  } else {
    // Si no hay teléfono registrado, usar entrada manual
    this.phoneOption = 'custom';
    console.log('📱 [INIT] Inicializando con entrada manual (sin teléfono por defecto)');
  }

  // ================================================================================
  // DEBUG: VERIFICAR ESTADO FLUJO BDV
  // ================================================================================
  console.log('🔍 [INIT] === ESTADO FLUJO BDV ===');
  console.log('🔍 [INIT] account.workflow:', this.account?.workflow);
  console.log('🔍 [INIT] selectView:', this.selectView);
  console.log('🔍 [INIT] simplifiedFlow.verification.matches:', this.simplifiedFlow.verification.matches);
  console.log('🔍 [INIT] account.payment_method.code:', this.account?.payment_method?.code);
  console.log('🔍 [INIT] person.person.phone:', this.person?.person?.phone);
  console.log('🔍 [INIT] ========================');

  // ================================================================================
  // INICIALIZACIÓN FECHA POR DEFECTO
  // ================================================================================
  // Asegurar que la fecha por defecto (HOY) se cargue en los campos del formulario
  setTimeout(() => {
    this.ensureDateFieldsAreFilled();
    if (this.dateOption === 'today') {
      console.log('📅 [INIT] Estableciendo fecha HOY por defecto en formulario...');
      this.setDateOption('today');
    }
  }, 150);
    
    // Si no es flujo simplificado pero es PAGO_MOVIL, cargar teléfono automáticamente
    if (!this.simplifiedFlow.enabled && this.account?.payment_method?.code === 'PAGO_MOVIL' && this.account?.type_customer !== 'CUSTOMER') {
      console.log('📞📞📞 [TRADITIONAL] PROGRAMANDO carga de teléfono para flujo tradicional homologado...');
      setTimeout(async () => {
        console.log('📞📞📞 [TRADITIONAL] EJECUTANDO loadUserPhoneForBDV para flujo tradicional...');
        try {
          await this.loadUserPhoneForBDV();
          console.log('📞📞📞 [TRADITIONAL] loadUserPhoneForBDV COMPLETADO para flujo tradicional');
        } catch (error) {
          console.error('💥 [TRADITIONAL] ERROR en loadUserPhoneForBDV:', error);
        }
      }, 100); // 100ms de delay para asegurar inicialización
    }

  if(!this.paymentEdit){

    this.form.get('total_amount').setValue('');
    this.form.get('total_amount').patchValue('');

    /*if(this.deuda_total>0) {
      if(this.account?.currency?.code==='USD'){
        this.form.patchValue({ total_amount: this.deuda_total  });
      } else {
        this.form.patchValue({ total_amount: this.deuda_total * this.rate?.amount.toFixed(2) });
      }
    }*/

    this.changeMount();
    this.minAmount = this.minPayment();
    this.validateTotalAmountMin();

  }

  this.offcanvasService.dismiss();

}


selectAccount2(account:any){
  this.avisoConfirmado = false;
  this.account_payment = account?.code;
  this.account = account;

  if(this.account.reference_length) {
    this.reference_length_max = this.account.reference_length;
    this.reference_length = this.account.reference_length;
  } else {
    this.reference_length = this.reference_default_length;
    this.reference_length_max = this.reference_default_length;
  }

  this.validateReferenceLength();
}

getRate = async (date= null,init=false,changeMount =false) => {
  try {
    this.rate_error = false;

    this.rate_load = true;

    let data:any =  { "subscriptor":1};

    if(date){
          data = { date,subscriptor:1}
      }

      try {
        const  respose  = await this._user.getRate(data);
        if(!respose)
        this.rate_error = true;

        let rate = respose?.res;

        this.rate = rate;
        if(changeMount){

          this.changeMount();

        }
        this.rate_load = false;

        if(init){
          this.getPersonInstallmentsInvoiceCredits(this.invoiceParams);

        }

      } catch (error) {
        console.log(error);
        this.rate_error = true;
        this.rate_load = false;

      }


  } catch (error) {
    console.log(error);
  }

};


 toFixedApp = (x:any) => {

  let a:any = `e+${2}`;
  let b:any = `e-${2}`;

  return +(Math.round(x + a) + b);

  //return Number(Number.parseFloat(String((x + Number.EPSILON))).toFixed(TOFIXED));

}


pec = () => {
  return (this.amountF) < 0;
}

pexe = () => {
  let result =  this.amountF  ;
  return result;
}


dateSet(e: any) {

  let date_base =  e.valueText;

  let  temp = date_base? date_base.split("/") : [];
  this.date_base_string = `${temp[1]}/${temp[0]}/${temp[2]}`;

  // Cuando el usuario selecciona una fecha manualmente, cambiar a 'custom'
  this.dateOption = 'custom';

  // ================================================================================
  // RESET BDV: Limpiar paymentToken cuando cambia la fecha
  // ================================================================================
  if (this.account?.workflow === 'workflow_verificacion_bdv') {
    this.resetBDVFlowOnDataChange();
  }

  this.getRate(this.date_base_string,false,true);
  
  // ================================================================================
  // AUTO-BÚSQUEDA BDV: Verificar si podemos ejecutar búsqueda automática (inmediata)
  // ================================================================================
  setTimeout(() => this.checkAndAutoSearchBDVWithDebounce(false), 200);
}

// Variable para controlar la opción de fecha seleccionada
dateOption: 'today' | 'yesterday' | 'custom' = 'today';

// Variable para controlar la opción de teléfono seleccionada
phoneOption: 'default' | 'custom' = 'default';

// Método para establecer la opción de fecha
setDateOption(option: 'today' | 'yesterday' | 'custom') {
  console.log(`📅 [DATE] Cambiando opción de fecha a: ${option}`);
  this.dateOption = option;
  
  // ================================================================================
  // RESET BDV: Limpiar paymentToken cuando cambia la fecha
  // ================================================================================
  if (this.account?.workflow === 'workflow_verificacion_bdv') {
    this.resetBDVFlowOnDataChange();
  }
  
  if (option === 'today') {
    const today = new Date();
    this.date_base = today;
    this.date_base_string = this.datePipe.transform(today, 'MM/dd/yyyy');
    
    // IMPORTANTE: Actualizar también los campos del formulario
    this.form.patchValue({
      date_base: today,
      date_base_string: this.date_base_string
    });
    
    console.log(`📅 [DATE] ✅ Fecha HOY establecida: ${this.date_base_string}`);
    this.getRate(this.date_base_string, false, true);
    
    // ================================================================================
    // AUTO-BÚSQUEDA BDV: Verificar si podemos ejecutar búsqueda automática (inmediata)
    // ================================================================================
    setTimeout(() => this.checkAndAutoSearchBDVWithDebounce(false), 200);
  } else if (option === 'yesterday') {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    this.date_base = yesterday;
    this.date_base_string = this.datePipe.transform(yesterday, 'MM/dd/yyyy');
    
    // IMPORTANTE: Actualizar también los campos del formulario
    this.form.patchValue({
      date_base: yesterday,
      date_base_string: this.date_base_string
    });
    
    console.log(`📅 [DATE] ✅ Fecha AYER establecida: ${this.date_base_string}`);
    this.getRate(this.date_base_string, false, true);
    
    // ================================================================================
    // AUTO-BÚSQUEDA BDV: Verificar si podemos ejecutar búsqueda automática (inmediata)
    // ================================================================================
    setTimeout(() => this.checkAndAutoSearchBDVWithDebounce(false), 200);
  }
  // Para 'custom' no hacemos nada aquí, el usuario seleccionará manualmente
  console.log(`📅 [DATE] Valores actuales - date_base: ${this.date_base}, date_base_string: ${this.date_base_string}`);
}

// Métodos para botones de fecha rápida (mantenidos para compatibilidad)
setTodayDate() {
  this.setDateOption('today');
}

setYesterdayDate() {
  this.setDateOption('yesterday');
}

isToday(date: Date): boolean {
  if (!date) return false;
  const today = new Date();
  const compareDate = new Date(date);
  return compareDate.toDateString() === today.toDateString();
}

isYesterday(date: Date): boolean {
  if (!date) return false;
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  const compareDate = new Date(date);
  return compareDate.toDateString() === yesterday.toDateString();
}

// Métodos para manejo de teléfono
setPhoneOption(option: 'default' | 'custom') {
  console.log(`📱 [PHONE] Cambiando opción de teléfono a: ${option}`);
  console.log(`📱 [PHONE] Person disponible:`, this.person);
  console.log(`📱 [PHONE] Person.person.phone:`, this.person?.person?.phone);
  
  // ================================================================================
  // RESET BDV: Limpiar paymentToken cuando cambia el teléfono
  // ================================================================================
  if (this.account?.workflow === 'workflow_verificacion_bdv') {
    this.resetBDVFlowOnDataChange();
  }
  
  this.phoneOption = option;
  
  if (option === 'default' && this.person?.person?.phone) {
    // Usar teléfono por defecto de la persona
    const { phoneCode, phoneNumber } = this.parsePhoneNumber(this.person.person.phone);
    console.log(`📱 [PHONE] Parsing resultado: código=${phoneCode}, número=${phoneNumber}`);
    
    this.form.patchValue({
      code_phone: phoneCode,
      phone: phoneNumber
    });
    
    // ================================================================================
    // VALIDACIÓN: Marcar teléfono como válido cuando se usa el por defecto
    // ================================================================================
    this.validationPhone = true;
    console.log(`📱 [PHONE] ✅ Teléfono por defecto establecido: ${phoneCode} ${phoneNumber}`);
    console.log(`📱 [PHONE] ✅ validationPhone marcado como: ${this.validationPhone}`);
    
    // ================================================================================
    // AUTO-BÚSQUEDA BDV: Verificar si podemos ejecutar búsqueda automática (inmediata)
    // ================================================================================
    setTimeout(() => this.checkAndAutoSearchBDVWithDebounce(false), 100);
  } else if (option === 'custom') {
    // Limpiar campos para entrada manual
    this.form.patchValue({
      code_phone: '',
      phone: ''
    });
    // Reset validación cuando se cambia a custom (se validará en validateNumberPhone)
    this.validationPhone = false;
    console.log('📱 [PHONE] ✅ Campos limpiados para entrada manual');
    console.log(`📱 [PHONE] ✅ validationPhone reset a: ${this.validationPhone}`);
  } else {
    console.log(`📱 [PHONE] ❌ No se pudo establecer opción por defecto. Person.phone: ${this.person?.person?.phone}`);
  }
}

formatPhoneDisplay(phone: string): string {
  if (!phone) return '';
  
  const { phoneCode, phoneNumber } = this.parsePhoneNumber(phone);
  return `${phoneCode} ${phoneNumber}`;
}

parsePhoneNumber(phone: string): { phoneCode: string, phoneNumber: string } {
  if (!phone) return { phoneCode: '', phoneNumber: '' };
  
  // Ejemplo: +584241318534
  if (phone.startsWith('+58')) {
    // Extraer después de +58
    const remaining = phone.substring(3); // 4241318534
    
    // Los primeros 3 dígitos son el código de operadora
    if (remaining.length >= 10) { // 424 + 7 dígitos mínimo
      const operatorCode = remaining.substring(0, 3); // 424
      const phoneNumber = remaining.substring(3); // 1318534
      
      return {
        phoneCode: '0' + operatorCode, // 0424
        phoneNumber: phoneNumber
      };
    }
  }
  
  // Fallback: tratar de parsear si ya está en formato 0424xxxxxxx
  if (phone.startsWith('0') && phone.length >= 11) {
    return {
      phoneCode: phone.substring(0, 4), // 0424
      phoneNumber: phone.substring(4) // xxxxxxx
    };
  }
  
  // Si no se puede parsear, devolver el teléfono completo como número
  return {
    phoneCode: '',
    phoneNumber: phone
  };
}

// Método para garantizar que los campos de teléfono estén llenos cuando se usa opción por defecto
ensurePhoneFieldsAreFilled() {
  console.log('📱 [ENSURE] Verificando que campos de teléfono estén llenos...');
  
  if (this.phoneOption === 'default' && this.person?.person?.phone) {
    const { phoneCode, phoneNumber } = this.parsePhoneNumber(this.person.person.phone);
    
    // Verificar si los campos ya están llenos
    const currentPhoneCode = this.form.get('code_phone')?.value;
    const currentPhone = this.form.get('phone')?.value;
    
    if (!currentPhoneCode || !currentPhone) {
      console.log('📱 [ENSURE] ⚠️ Campos vacíos, rellenando...');
      this.form.patchValue({
        code_phone: phoneCode,
        phone: phoneNumber
      });
      console.log(`📱 [ENSURE] ✅ Campos rellenados: ${phoneCode} ${phoneNumber}`);
    } else {
      console.log(`📱 [ENSURE] ✅ Campos ya estaban llenos: ${currentPhoneCode} ${currentPhone}`);
    }
    
    // ================================================================================
    // VALIDACIÓN: Asegurar que validationPhone esté en true para número por defecto
    // ================================================================================
    this.validationPhone = true;
    console.log(`📱 [ENSURE] ✅ validationPhone establecido a: ${this.validationPhone}`);
    
    // ================================================================================
    // AUTO-BÚSQUEDA BDV: Verificar si podemos ejecutar búsqueda automática (inmediata)
    // ================================================================================
    setTimeout(() => this.checkAndAutoSearchBDVWithDebounce(false), 100);
  } else {
    console.log('📱 [ENSURE] ℹ️ No se requiere relleno (opción custom o sin teléfono por defecto)');
  }
}

// Método para garantizar que los campos de fecha estén llenos cuando se usan opciones predefinidas
ensureDateFieldsAreFilled() {
  console.log('📅 [ENSURE] Verificando que campos de fecha estén llenos...');
  
  // Verificar si los campos de fecha están llenos
  const currentDateBase = this.form.get('date_base')?.value;
  const currentDateString = this.form.get('date_base_string')?.value;
  
  if ((!currentDateBase || !currentDateString) && this.dateOption !== 'custom') {
    console.log('📅 [ENSURE] ⚠️ Campos de fecha vacíos, rellenando según opción actual...');
    
    if (this.dateOption === 'today') {
      this.setDateOption('today');
    } else if (this.dateOption === 'yesterday') {
      this.setDateOption('yesterday');
    }
  } else {
    console.log(`📅 [ENSURE] ✅ Campos de fecha OK: ${currentDateString}`);
  }
}



setAmount() {
  let amountFB =  this.toFixedApp((this.installment?.dueBalance - this.totalpaymentReference)) ;

  let account = this.account;
  this.deduction_payment.forEach((v:any, key:any) => {

    if((v?.currency?.code == account?.currency?.code) || !v?.currency ){
      if(v.isPorcent){
        let resp = v?.amount || 0;


         let porcent = this.toFixedApp(this.toFixedApp((amountFB * resp) / 100));

          amountFB = this.toFixedApp(amountFB + porcent);
      }
    }


});

this.amountFB = amountFB;

}

notamounmax(){
  const form = this.form.getRawValue().total_amount;

}

gotoWhatsapp(num:any) : void {

  window.open(" https://wa.me/"+num?.replace('+', ''), "_blank");
}


getBanks = async () => {
  try {

    const resp = await this.getBanksServer();

    this.banks =   resp.res.filter((item:any)=>{

        return item.bankCode? true : false;

    })


  } catch (error) {
    console.error(error);

  }




}


getTypeProducts = async () => {
  try {

    const resp = await this.getTypeProductsServer();

    this.typeProducts =   resp.res;


  } catch (error) {
    console.error(error);

  }

}

getTypeProductsServer = async () => {
  try{
      return this._user.getTypeProducts({});

    } catch (error) {
      console.error(error);


    }
}

getBanksServer = async () => {
  try{
      return this._user.getBanks({});

    } catch (error) {
      console.error(error);


    }
}

validatePhone = () =>{


  let campo = this.form.controls.phone.value;
   if(this.account?.payment_method?.code == 'PAGO_MOVIL'){


     if(campo &&  /^\d+$/.test(campo) && campo.length > 6){


       let valueCampo = campo.substr(0, 7);

       this.form.get('phone').setValue(valueCampo);


     this.validationPhone = true;
    
    // ================================================================================
    // AUTO-BÚSQUEDA BDV: Verificar si podemos ejecutar búsqueda automática (inmediata)
    // ================================================================================
    setTimeout(() => this.checkAndAutoSearchBDVWithDebounce(false), 100);

   }else{

     this.validationPhone = false;


   }
 }



}
validateNumberReference = ( min: any, max: any) =>{
  let campo = this.form.controls.reference.value;
  if(campo.length >= min && campo.length <= max){
    this.validationReference = true;
    
    // ================================================================================
    // AUTO-BÚSQUEDA BDV: Ejecutar búsqueda automática si estamos en flujo BDV
    // Incluye 'multiple' (estado inicial) y 'none' (después de no encontrar)
    // ================================================================================
    if (this.account?.workflow === 'workflow_verificacion_bdv' && 
        (this.simplifiedFlow.verification.matches === 'multiple' || 
         this.simplifiedFlow.verification.matches === 'none')) {
      console.log('[BDV-REF-AUTO] 🔍 Referencia válida ingresada/modificada, ejecutando búsqueda automática...');
      
      // Restaurar estado a múltiple para nueva búsqueda
      this.simplifiedFlow.verification.matches = 'multiple';
      
      // Si ya tenía un paymentToken, borrarlo para nueva búsqueda
      if (this.simplifiedFlow.data.paymentToken) {
        console.log('[BDV-REF-AUTO] ♻️ Borrando paymentToken previo para nueva búsqueda');
        this.simplifiedFlow.data.paymentToken = null;
      }
      
      setTimeout(() => this.checkAndAutoSearchBDVWithReference(), 100);
    }
    
    // } else if(campo &&  /^\d+$/.test(campo) && campo.length > max){
    //   let valueCampo = campo.substr(0, max);
    //   this.form.get('reference').setValue(valueCampo);
    //   this.validationReference = true;
  } else {
    this.validationReference = false;
    
    // ================================================================================
    // RESET BDV: Si la referencia se vuelve inválida, resetear estado
    // ================================================================================
    if (this.account?.workflow === 'workflow_verificacion_bdv' && 
        (this.simplifiedFlow.verification.matches === 'multiple' || 
         this.simplifiedFlow.verification.matches === 'none')) {
      console.log('[BDV-REF-AUTO] ❌ Referencia inválida, reseteando paymentToken');
      this.simplifiedFlow.data.paymentToken = null;
      // Resetear a múltiple para nueva búsqueda cuando sea válida
      this.simplifiedFlow.verification.matches = 'multiple';
    }
  }

}





/*validateNumberReference = () =>{


  let campo = this.form.controls.reference.value;

   if(this.account?.bank?.name != 'Zelle'){

     if(this.account?.bank?.name != 'Mercantil'){
       if(campo &&  /^\d+$/.test(campo) && campo.length > 5){


         let valueCampo = campo.substr(0, 6);

         this.form.get('reference').setValue(valueCampo);


       this.validationReference = true;

       }else{

         this.validationReference = false;


       }
     } else {

      if(this.account?.payment_method?.code !== "PAGO_MOVIL") {
        if(campo &&  /^\d+$/.test(campo) && campo.length > 7){


          let valueCampo = campo.substr(0, 8);

          this.form.get('reference').setValue(valueCampo);


          this.validationReference = true;

        }else{

          this.validationReference = false;


        }
      } else {
        if(campo &&  /^\d+$/.test(campo) && campo.length > 5){


          let valueCampo = campo.substr(0, 6);

          this.form.get('reference').setValue(valueCampo);


          this.validationReference = true;

        }else{

          this.validationReference = false;


        }
      }



     }
 }



}*/




maxDuelbalance(){

  if(!this.paymentEdit){

    return this.form.getRawValue().total_amount > this.dueBalanceCurrecy;

  }else{
    return false;
  }
}

minPayment(){
  if(!this.paymentEdit){
    const isLiquidacion = this.typeProduct && (this.typeProduct.toLowerCase().includes('liquidacion') || this.typeProduct.toLowerCase().includes('liquidación'));
    
    // Para liquidaciones, el mínimo es 0 (cualquier monto es válido)
    if (isLiquidacion) {
      return 0;
    }
    
    let value = this.person.resumen.monto_minimo;
    if(this.account?.currency?.code == "BS"){
     value = this.toFixedApp(value * this.rate?.amount) ;
    }
    return value;

  } else {
    return 0;
  }

}

validateMinAmount(): void {

  const control = this.form.get('total_amount');
  control.clearValidators();

  control.setValidators([
    Validators.minLength(this.minPayment())
  ]);

  this.validateTotalAmountMin();

  control.updateValueAndValidity();
}

validateTotalAmountMin = () =>{
  let campo = this.form.controls.total_amount.value;

  // Simplificar: solo validar que el monto sea mayor a 0 (no validar mínimos)
  if(campo > 0){
    this.validationMinAmount = true;
    
    // ================================================================================
    // RESET BDV: Limpiar paymentToken cuando cambia el monto
    // ================================================================================
    if (this.account?.workflow === 'workflow_verificacion_bdv' && this.lastAmountValue !== campo) {
      this.resetBDVFlowOnDataChange();
    }
    
    // ================================================================================
    // AUTO-BÚSQUEDA BDV: Solo ejecutar si hay cambio real en el valor (con debounce)
    // ================================================================================
    // Verificar si realmente cambió el valor para evitar búsquedas innecesarias
    if (this.lastAmountValue !== campo) {
      console.log(`💰 [DEBOUNCE] Cambio detectado: ${this.lastAmountValue} → ${campo}`);
      this.lastAmountValue = campo; // Actualizar el último valor
      this.checkAndAutoSearchBDVWithDebounce(true); // true = usar debounce para monto
    } else {
      console.log(`💰 [DEBOUNCE] Sin cambio en monto: ${campo} (skipping search)`);
    }
  } else {
    this.validationMinAmount = false;
  }

}




minDuelbalance(){

  if(!this.paymentEdit){

    return this.form.getRawValue().total_amount > this.minPayment();

  }else{
    return false;
  }
}

validateAccountNumber = () =>{

  let campo = this.form.controls.accountNumber.value;

   if(this.account?.bank?.name != 'Zelle'){

     if(campo &&  /^\d+$/.test(campo) && campo.length > 5){

       let valueCampo = campo.substr(0, 6);

       this.form.get('accountNumber').setValue(valueCampo);


     this.validationAccountNumber = true;

   }else{

     this.validationAccountNumber = false;


   }
 }



}

moveCursorToEnd(event: any) {
  const input = event.target;
  input.selectionStart = input.selectionEnd = input.value.length;
}

// Método para volver atrás
goBack() {
  this.location.back();
}


// Mario: si hay morosidad
getFeeApply = async() => {
  try {
    if(this.person && this.person?.resumen?.aplica_fee) {
        this.concept_deduction_apply = this.person?.resumen?.installments_morosos;

        // calculo el total a pagar, deuda total + fees
        let fees_amount =  this.concept_deduction_apply.reduce((accum: any, current: any) => {
          return accum + current?.amount_fee;
        }, 0);
        this.deuda_total = fees_amount + this.person.resumen.monto_adeudado_vencido;

    } else {
      this.deuda_total = 0;
    }
  } catch (error) {
    this.fee_to_apply = null;
    console.log(error);
  }
}

getFeeExtend = async() => {
  try {
    // if(this.person && this.feeParams && this.installmentParams) {
    let response = await this.feeService.findExtendFee(null, this.installmentParams, this.feeParams);
    debugger;
    this.concept_deduction_apply =  response.installments;

    // calculo el total a pagar, deuda total + fees
    let fees_amount =  this.concept_deduction_apply.reduce((accum: any, current: any) => {
      return accum + current?.amount_fee;
    }, 0);

    this.deuda_total = fees_amount;


    // }
  } catch (error) {
    this.fee_to_apply = null;
    console.log(error);
  }
}

deleteFee = async (fee: any) => {
  const result = await Swal.fire({
    title: '¿Deseas eliminar la penalidad?',
    text: 'Una vez se guarden los cambios, no podrá ser revertido',
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    showCancelButton: true,
    confirmButtonText: 'Sí, eliminar!',
    showLoaderOnConfirm: true,
    allowOutsideClick: () => !Swal.isLoading(),
  });

  if (result.isConfirmed) {
    try {
     this.fee_delete.push(fee._id);
    } catch (error) {
      console.error(error);

    }
  }
}

async consultAllProductsInvoices(){
  console.log('=== consultAllProductsInvoices called ===');
  try {

    const form = {
      "status": ["ACTIVE", "PENDING"],
      "audience": "NATURAL",
      "paginate": false
    }

    let consultProducts = await this._user.getTypesProductsInvoices();
    console.log('getTypesProductsInvoices response:', consultProducts);

    this.productArray = consultProducts.resp;
    this.filteredProductArray = [...this.productArray]; // Initialize filtered array

    console.log('Products loaded:', this.productArray.length);
    console.log('Sample product:', this.productArray[0]);
    
    // 💎 Establecer CREDIT como valor por defecto en el término de búsqueda
    this.productSearchTerm = 'CREDIT';

  } catch (error) {
    console.error('Error loading products:', error);
  }
}

// Método para el botón aplicar
async aplicarInput() {
  console.log('=== aplicarInput called ===');
  console.log('inputValue:', this.inputValue);

  if (this.inputValue && this.inputValue.trim() !== '') {
    console.log('Applying input value:', this.inputValue);

    try {
      // Llamar al servicio con el código dinámico
      this.accountPayment_load = true;
      console.log('Loading accounts with code:', this.inputValue.trim());

      const resp = await this._user.account_payment({ code: this.inputValue.trim(), perfil_activo: 1 });
      console.log('Account payment response:', resp);

      if (resp?.res) {
        this.accountPayment = resp.res;
        this.filteredAccounts = [...(this.accountPayment || [])];
        console.log('Accounts loaded successfully:', this.accountPayment.length, 'accounts');
      } else {
        console.log('No accounts found for code');
        alertifyjs.error('No se encontraron cuentas para este código');
        this.filteredAccounts = [];
      }

      this.accountPayment_load = false;

    } catch (error) {
      console.error('Error al consultar cuentas con código dinámico:', error);
      alertifyjs.error('Error al consultar las cuentas');
      this.accountPayment_load = false;
      this.filteredAccounts = [];
    }
  } else {
    console.log('No input value provided');
  }
}

// Método para resetear el código y recargar cuentas originales
async resetCode() {
  this.inputValue = '';
  this.getAccountPayment();
}

// Método para filtrar cuentas en el modal
filterAccounts() {
  if (!this.accountPayment) {
    this.filteredAccounts = [];
    return;
  }

  if (!this.searchTerm || this.searchTerm.trim() === '') {
    this.filteredAccounts = [...this.accountPayment];
    return;
  }

  const term = this.searchTerm.toLowerCase().trim();
  this.filteredAccounts = this.accountPayment.filter((account: any) => {
    return (
      account?.bank?.name?.toLowerCase().includes(term) ||
      account?.payment_method?.name?.toLowerCase().includes(term) ||
      account?.number?.toLowerCase().includes(term) ||
      account?.taxId?.toLowerCase().includes(term) ||
      account?.phone?.toLowerCase().includes(term) ||
      account?.email?.toLowerCase().includes(term) ||
      account?.currency?.name?.toLowerCase().includes(term) ||
      account?.currency?.code?.toLowerCase().includes(term) ||
      account?.tag?.toLowerCase().includes(term)
    );
  });
}

// Método para manejar el cambio de tipo de producto
onProductTypeChange(event: any) {
  const selectedProductCode = event.target.value;

  // Si cambia el tipo de producto, limpiar cuenta seleccionada
  if (this.typeProduct !== selectedProductCode) {
    this.clearSelectedAccount();
  }

  this.typeProduct = selectedProductCode;

  if (selectedProductCode) {
    console.log('Product type selected:', selectedProductCode);

    // Automatically apply the dynamic code when product is selected
    this.inputValue = selectedProductCode;
    this.aplicarInput();
  } else {
    // Reset to show all accounts when no product is selected
    this.resetCode();
  }
}

// Método para obtener el código dinámico de un producto
getProductDynamicCode(product: any): string {
  // Devolver el código del producto
  return product?.params?.code || product?.code || '';
}

// Método para obtener el nombre del producto seleccionado
getSelectedProductName(): string {
  if (!this.typeProduct || !this.productArray) {
    return '';
  }

  const selectedProduct = this.productArray.find(item =>
    this.getProductDynamicCode(item) === this.typeProduct
  );
  return selectedProduct?.params?.name || selectedProduct?.name || selectedProduct?.params?.code || '';
}

// Método para filtrar productos
filterProducts() {
  if (!this.productArray) {
    this.filteredProductArray = [];
    return;
  }

  if (!this.productSearchTerm || this.productSearchTerm.trim() === '') {
    // Si no hay término de búsqueda, mostrar todos los productos
    this.filteredProductArray = [...this.productArray];
    return;
  }

  const term = this.productSearchTerm.toLowerCase().trim();
  this.filteredProductArray = this.productArray.filter((product: any) => {
    return (
      product?.params?.name?.toLowerCase().includes(term) ||
      product?.name?.toLowerCase().includes(term) ||
      product?.params?.code?.toLowerCase().includes(term)
    );
  });
}

// Método para seleccionar un producto
selectProduct(product: any) {
  console.log('=== selectProduct called ===');
  console.log('Selected product:', product);

  // Usar el código del producto como typeProduct
  const productCode = product?.params?.code || product?.code || '';
  
  if (!productCode) {
    console.error('Product has no code, cannot select');
    return;
  }

  console.log('Product code:', productCode);

  // Si cambia el tipo de producto, limpiar cuenta seleccionada
  if (this.typeProduct !== productCode) {
    console.log('Product type changed, clearing account');
    this.clearSelectedAccount();
  }

  // Actualizar siempre la selección con el código del producto
  this.typeProduct = productCode;
  this.productSearchTerm = product?.params?.name || product?.name || productCode;
  this.showProductDropdown = false;

  console.log('Updated typeProduct:', this.typeProduct);
  console.log('Updated productSearchTerm:', this.productSearchTerm);

  // Buscar código de cuenta bancaria en los códigos dinámicos del producto para filtrar cuentas
  let bankAccountCode = null;
  if (product?.params?.dinamic_code && product.params.dinamic_code.length > 0) {
    console.log('Product has dynamic codes:', product.params.dinamic_code);
    bankAccountCode = this.findBankAccountCode(product.params.dinamic_code);
    if (bankAccountCode) {
      console.log('Found bank account code for filtering:', bankAccountCode);
    }
  }

  // Cargar cuentas - si hay código bancario específico, usarlo para filtrar; si no, cargar todas
  if (bankAccountCode) {
    console.log('Applying specific bank account code filter:', bankAccountCode);
    this.inputValue = bankAccountCode;
    this.aplicarInput();
  } else {
    console.log('Loading all accounts (no specific bank code filter)');
    this.getAccountPayment(); // Cargar todas las cuentas
  }
}

// Método para mostrar el dropdown de productos
showProductOptions() {
  this.showProductDropdown = true;
  // Siempre mostrar todos los productos cuando se hace click en el buscador
  this.filteredProductArray = [...this.productArray];
}

// Método para ocultar el dropdown de productos
hideProductOptions() {
  // Delay to allow click events to register
  setTimeout(() => {
    this.showProductDropdown = false;
  }, 200);
}

// Método para limpiar la búsqueda de productos
clearProductSearch() {
  // Limpiar cuenta seleccionada cuando se limpia el producto
  this.clearSelectedAccount();

  this.productSearchTerm = '';
  this.typeProduct = '';
  this.showProductDropdown = false;
  this.resetCode();
}

// Método para cargar códigos dinámicos
async loadDynamicCodes() {
  console.log('=== loadDynamicCodes called ===');
  try {
    const response = await this._user.getAllCodes();
    console.log('getAllCodes response:', response);

    if (response && response.data) {
      this.allDynamicCodes = response.data.filter((code: any) => code.status === true);
      this.bankAccountCodes = this.allDynamicCodes.filter((code: any) => code.category === 'bank_accounts');
      console.log('Dynamic codes loaded:', this.allDynamicCodes.length);
      console.log('Bank account codes loaded:', this.bankAccountCodes.length);
      console.log('Bank account codes:', this.bankAccountCodes);
    } else {
      console.log('No data in getAllCodes response');
      this.allDynamicCodes = [];
      this.bankAccountCodes = [];
    }
  } catch (error) {
    console.error('Error loading dynamic codes:', error);
    this.allDynamicCodes = [];
    this.bankAccountCodes = [];
  }
}

// Método para encontrar código de cuenta bancaria en la lista de códigos dinámicos del producto
findBankAccountCode(productDynamicCodes: string[]): string | null {
  console.log('=== findBankAccountCode called ===');
  console.log('productDynamicCodes:', productDynamicCodes);
  console.log('bankAccountCodes:', this.bankAccountCodes);

  if (!productDynamicCodes || productDynamicCodes.length === 0) {
    console.log('No product dynamic codes provided');
    return null;
  }

  // Buscar si algún código dinámico del producto corresponde a una cuenta bancaria
  for (const dynamicCode of productDynamicCodes) {
    console.log('Checking dynamic code:', dynamicCode);
    const bankCode = this.bankAccountCodes.find(code => code.code === dynamicCode);
    if (bankCode) {
      console.log('Bank account code found:', bankCode.code);
      return bankCode.code;
    }
  }

  console.log('No bank account code found in product dynamic codes');
  return null;
}

// Método para obtener códigos bancarios como string para mostrar en el template
getBankAccountCodesString(): string {
  if (!this.bankAccountCodes || this.bankAccountCodes.length === 0) {
    return 'Ninguno';
  }
  return this.bankAccountCodes.map(c => c.code).join(', ');
}

// ================================================================================
// MÉTODOS FLUJO SIMPLIFICADO BDV - Workflow Verificación
// ================================================================================

/**
 * Verificar si el account payment seleccionado tiene workflow_verificacion_bdv
 */
checkBDVWorkflow = async () => {
  console.log('🚀🚀🚀 [BDV] EJECUTANDO checkBDVWorkflow 🚀🚀🚀');
  console.log('[BDV DEBUG] account:', this.account);
  console.log('[BDV DEBUG] workflow value:', this.account?.workflow);
  console.log('[BDV DEBUG] workflow type:', typeof this.account?.workflow);
  
  if (this.account?.workflow === 'workflow_verificacion_bdv') {
    console.log('✅✅✅ [BDV] ACTIVANDO FLUJO SIMPLIFICADO para:', this.account.name);
    this.simplifiedFlow.enabled = true;
    this.simplifiedFlow.step = 'phone';
    this.resetSimplifiedFlow();
    
    // Inicializar seguimiento de monto
    this.lastAmountValue = this.form.get('total_amount')?.value || null;
    
    // Cargar automáticamente el teléfono del usuario con un pequeño delay
    console.log('📞📞📞 [BDV] PROGRAMANDO carga de teléfono...');
    setTimeout(async () => {
      console.log('📞📞📞 [BDV] EJECUTANDO loadUserPhoneForBDV AUTOMÁTICO...');
      try {
        await this.loadUserPhoneForBDV();
        console.log('📞📞📞 [BDV] loadUserPhoneForBDV AUTOMÁTICO COMPLETADO');
      } catch (error) {
        console.error('💥 [BDV] ERROR en loadUserPhoneForBDV AUTOMÁTICO:', error);
      }
    }, 100); // 100ms de delay para asegurar inicialización
  } else {
    console.log('❌❌❌ [BDV] FLUJO TRADICIONAL para:', this.account?.name || 'Sin selección');
    console.log('[BDV] ❌ Workflow actual:', this.account?.workflow || 'undefined');
    this.simplifiedFlow.enabled = false;
  }
};

/**
 * Resetear datos del flujo simplificado
 */
resetSimplifiedFlow = () => {
  console.log('🔄 [BDV] RESETEANDO simplifiedFlow...');
  this.simplifiedFlow.data = {
    phoneCode: null,
    phoneNumber: null,
    amount: null,
    reference: null,
    paymentToken: null,
    file: null
  };
  this.simplifiedFlow.verification = {
    matches: null,
    paymentData: null,
    requiresReference: false
  };
  this.simplifiedFlow.errors = {
    phone: '',
    amount: '',
    reference: '',
    file: ''
  };
  this.simplifiedFlow.loading = false;
  
  // Limpiar timer de debounce si existe
  if (this.autoSearchDebounceTimer) {
    clearTimeout(this.autoSearchDebounceTimer);
    this.autoSearchDebounceTimer = null;
  }
  
  // Reset del seguimiento de último valor de monto
  this.lastAmountValue = null;
  
  console.log('🔄 [BDV] simplifiedFlow RESETEADO:', this.simplifiedFlow.data);
};

/**
 * Cargar automáticamente el teléfono del usuario para el flujo BDV y tradicional homologado
 */
loadUserPhoneForBDV = async () => {
  try {
    console.log('🔥🔥🔥 [BDV] INICIANDO CARGA DE TELÉFONO 🔥🔥🔥');
    console.log('[BDV] this.person:', this.person);
    
    // Intentar obtener person code de diferentes fuentes
    let personCode = null;
    
    // Opción 1: Desde this.person.code (si está disponible)
    if (this.person?.code) {
      personCode = this.person.code;
      console.log('[BDV] ✅ Person code obtenido desde this.person.code:', personCode);
    }
    // Opción 2: Desde _auth.sessionUser.person_code (usuario autenticado)
    else if (this._auth.sessionUser?.person_code) {
      personCode = this._auth.sessionUser.person_code;
      console.log('[BDV] ✅ Person code obtenido desde _auth.sessionUser.person_code:', personCode);
    }
    // Opción 3: No hay código disponible
    else {
      console.error('❌ [BDV] No se encontró person code en ninguna fuente');
      console.error('❌ [BDV] this.person:', this.person);
      console.error('❌ [BDV] this._auth.sessionUser:', this._auth.sessionUser);
      alertifyjs.error('No se pudo cargar el teléfono: persona no encontrada');
      return;
    }
    
    console.log('[BDV] 🎯 Person code final a usar:', personCode);
    
    // Llamar al endpoint /api/person/code para obtener los contactos
    console.log('🌐 [BDV] Llamando API getPersonbyCode con código:', personCode);
    const personData = await this._user.getPersonbyCode({ code: personCode });
    
    console.log('🌐 [BDV] Respuesta de la API:', personData);
    console.log('🌐 [BDV] personData.constacts:', personData?.constacts);
    console.log('🌐 [BDV] Cantidad de contactos:', personData?.constacts?.length);
    
    if (personData && personData.constacts && personData.constacts.length > 0) {
      // Buscar el contacto de tipo PHONE_CELL (que debería estar primero por el ordenamiento)
      console.log('🔍 [BDV] Buscando contacto PHONE_CELL...');
      console.log('🔍 [BDV] Todos los contactos:', personData.constacts);
      
      const phoneContact = personData.constacts.find((contact: any) => 
        contact.type_contact?.code === 'PHONE_CELL'
      );
      
      console.log('🔍 [BDV] Contacto PHONE_CELL encontrado:', phoneContact);
      
      if (phoneContact && phoneContact.contact) {
        // Procesar el número de teléfono para separar código y número
        let phoneNumber = phoneContact.contact;
        
        console.log('[BDV] Teléfono original:', phoneNumber);
        
        // Convertir +58 a 0 (ejemplo: +584241318534 -> 04241318534)
        if (phoneNumber.startsWith('+58')) {
          phoneNumber = '0' + phoneNumber.substring(3);
          console.log('[BDV] Teléfono después de convertir +58 a 0:', phoneNumber);
        }
        
        // Separar código y número (ejemplo: 04241318534 -> 0424 y 1318534)
        if (phoneNumber.length >= 11 && phoneNumber.startsWith('0')) {
          const phoneCode = phoneNumber.substring(0, 4); // 0424, 0412, etc.
          const phoneNum = phoneNumber.substring(4);    // 1318534
          
          // Cargar en flujo simplificado
          if (this.simplifiedFlow.enabled) {
            this.simplifiedFlow.data.phoneCode = phoneCode;
            this.simplifiedFlow.data.phoneNumber = phoneNum;
            console.log('[BDV] ✅ Flujo simplificado - phoneCode:', phoneCode, 'phoneNumber:', phoneNum);
          } else {
            // Cargar en formulario tradicional homologado
            this.form.patchValue({
              code_phone: phoneCode,
              phone: phoneNum
            });
            console.log('[BDV] ✅ Flujo tradicional - code_phone:', phoneCode, 'phone:', phoneNum);
          }
          
          console.log('🎉 [BDV] TELÉFONO CARGADO EXITOSAMENTE:');
          console.log('[BDV] ✅ Select:', phoneCode, 'Input:', phoneNum);
          console.log('[BDV] ✅ simplifiedFlow.enabled:', this.simplifiedFlow.enabled);
          console.log('[BDV] ✅ Form values:', this.form.value);
          
          // Forzar detección de cambios
          setTimeout(() => {
            console.log('⏰ [BDV] Estado después de 500ms - simplifiedFlow:', this.simplifiedFlow.data);
            console.log('⏰ [BDV] Estado después de 500ms - form:', this.form.value);
          }, 500);
          
          alertifyjs.success('Teléfono cargado automáticamente: ' + phoneCode + phoneNum);
        } else {
          console.warn('[BDV] ⚠️ Formato de teléfono no reconocido:', phoneNumber);
          console.warn('[BDV] ⚠️ Longitud:', phoneNumber.length, 'Inicia con 0:', phoneNumber.startsWith('0'));
        }
      } else {
        console.warn('[BDV] No se encontró contacto de tipo PHONE_CELL');
      }
    } else {
      console.warn('[BDV] No se encontraron contactos para la persona');
    }
  } catch (error: any) {
    console.error('💥💥💥 [BDV] ERROR al cargar teléfono automáticamente:', error);
    alertifyjs.error('Error al cargar teléfono: ' + (error?.message || 'Error desconocido'));
  }
};

/**
 * MÉTODO TEMPORAL PARA TESTING - Cargar teléfono usando la API real
 */
testLoadPhoneBDV = async () => {
  console.log('🧪🧪🧪 [BDV] TESTING - Ejecutando MISMA función que automática...');
  
  try {
    // Llamar exactamente la misma función que se ejecuta automáticamente
    await this.loadUserPhoneForBDV();
    console.log('🧪 [BDV] TEST - loadUserPhoneForBDV completado exitosamente');
  } catch (error) {
    console.error('🧪💥 [BDV] TEST - ERROR en loadUserPhoneForBDV:', error);
    alertifyjs.error('TEST ERROR: ' + (error as any)?.message);
  }
};

/**
 * Avanzar al siguiente paso del flujo
 */
nextStepBDV = async () => {
  this.simplifiedFlow.errors = { phone: '', amount: '', reference: '', file: '' };

  switch (this.simplifiedFlow.step) {
    case 'phone':
      if (!this.simplifiedFlow.data.phoneCode || !this.simplifiedFlow.data.phoneNumber || 
          this.simplifiedFlow.data.phoneNumber.trim() === '') {
        this.simplifiedFlow.errors.phone = 'Debes seleccionar el código y completar el número';
        return;
      }
      if (this.simplifiedFlow.data.phoneNumber.length !== 7) {
        this.simplifiedFlow.errors.phone = 'El número debe tener exactamente 7 dígitos';
        return;
      }
      this.simplifiedFlow.step = 'amount';
      break;

    case 'amount':
      if (!this.simplifiedFlow.data.amount || parseFloat(this.simplifiedFlow.data.amount) <= 0) {
        this.simplifiedFlow.errors.amount = 'El monto debe ser mayor a 0';
        return;
      }
      await this.verifyPaymentBDV();
      break;

    case 'reference':
      if (!this.simplifiedFlow.data.reference || this.simplifiedFlow.data.reference.trim() === '') {
        this.simplifiedFlow.errors.reference = 'La referencia es obligatoria';
        return;
      }
      await this.confirmPaymentBDV();
      break;

    case 'upload':
      if (!this.simplifiedFlow.data.file) {
        this.simplifiedFlow.errors.file = 'El comprobante es obligatorio';
        return;
      }
      await this.registerPaymentBDV();
      break;
  }
};

/**
 * Retroceder al paso anterior
 */
previousStepBDV = () => {
  switch (this.simplifiedFlow.step) {
    case 'amount':
      this.simplifiedFlow.step = 'phone';
      break;
    case 'reference':
      this.simplifiedFlow.step = 'amount';
      break;
    case 'upload':
      if (this.simplifiedFlow.verification.matches === 'multiple') {
        this.simplifiedFlow.step = 'reference';
      } else {
        this.simplifiedFlow.step = 'amount';
      }
      break;
    case 'confirm':
      this.simplifiedFlow.step = 'upload';
      break;
  }
};

/**
 * Verificar pago con servicio BDV
 */
/**
 * Búsqueda automática con debounce para evitar múltiples llamados
 */
checkAndAutoSearchBDVWithDebounce = (useDebounce: boolean = true) => {
  // Limpiar timer existente
  if (this.autoSearchDebounceTimer) {
    clearTimeout(this.autoSearchDebounceTimer);
    this.autoSearchDebounceTimer = null;
  }

  if (useDebounce) {
    console.log(`[BDV-DEBOUNCE] ⏰ Programando búsqueda automática en ${this.DEBOUNCE_DELAY}ms...`);
    this.autoSearchDebounceTimer = setTimeout(() => {
      this.checkAndAutoSearchBDV();
    }, this.DEBOUNCE_DELAY);
  } else {
    // Ejecutar inmediatamente (para cambios de fecha y teléfono)
    this.checkAndAutoSearchBDV();
  }
};

/**
 * Verificar automáticamente si todos los campos requeridos están completos para ejecutar búsqueda BDV
 */
checkAndAutoSearchBDV = async () => {
  // Solo ejecutar si está habilitado el flujo BDV
  if (this.account?.workflow !== 'workflow_verificacion_bdv') {
    return;
  }

  console.log('[BDV-AUTO] 🔍 Verificando campos para búsqueda automática...');
  
  // Verificar que tenemos fecha
  const hasDate = this.date_base && this.date_base_string;
  
  // Verificar que tenemos teléfono completo
  const phoneCode = this.form.get('code_phone')?.value;
  const phoneNumber = this.form.get('phone')?.value;
  const hasPhone = phoneCode && phoneNumber && this.validationPhone;
  
  // Verificar que tenemos monto válido
  const amount = this.form.get('total_amount')?.value;
  const hasAmount = amount && amount > 0;
  
  console.log('[BDV-AUTO] 📊 Estado campos:', {
    hasDate,
    hasPhone: !!hasPhone,
    hasAmount: !!hasAmount,
    validationPhone: this.validationPhone,
    amount: amount
  });
  
  // Si todos los campos están completos, ejecutar búsqueda automática
  if (hasDate && hasPhone && hasAmount) {
    console.log('[BDV-AUTO] ✅ Todos los campos completos, ejecutando búsqueda automática...');
    
    // Mostrar indicador de búsqueda
    this.simplifiedFlow.loading = true;
    this.simplifiedFlow.step = 'searching';
    
    try {
      await this.verifyPaymentBDV();
    } catch (error) {
      console.error('[BDV-AUTO] ❌ Error en búsqueda automática:', error);
      // En caso de error, volver al paso anterior
      this.simplifiedFlow.step = 'phone';
    }
  } else {
    console.log('[BDV-AUTO] ⏳ Campos incompletos, esperando...');
    // Reset de verificación si faltan campos
  this.simplifiedFlow.verification.matches = null;
  this.simplifiedFlow.data.paymentToken = null;
  }
};

// ================================================================================
// AUTO-BÚSQUEDA BDV CON REFERENCIA: Para múltiples pagos con referencia completa
// ================================================================================
checkAndAutoSearchBDVWithReference = async () => {
  // Solo ejecutar si está habilitado el flujo BDV (múltiple o none después de no encontrar)
  if (this.account?.workflow !== 'workflow_verificacion_bdv' ||
      (this.simplifiedFlow.verification.matches !== 'multiple' && 
       this.simplifiedFlow.verification.matches !== 'none') ||
      this.simplifiedFlow.loading) {
    return;
  }

  console.log('[BDV-REF-AUTO] 🔍 Verificando campos para búsqueda automática con referencia...');
  
  // Verificar que tenemos referencia válida
  const referenceValue = this.form.get('reference')?.value;
  const hasValidReference = referenceValue && this.validationReference;
  
  console.log('[BDV-REF-AUTO] 📊 Estado referencia:', {
    referenceValue,
    hasValidReference,
    validationReference: this.validationReference
  });
  
  // Si la referencia está completa y válida, ejecutar confirmación automática
  if (hasValidReference) {
    console.log('[BDV-REF-AUTO] ✅ Referencia válida completa, ejecutando confirmación automática...');
    
    // Mostrar indicador de búsqueda
    this.simplifiedFlow.loading = true;
    
    try {
      await this.confirmPaymentBDVWithReference();
    } catch (error) {
      console.error('[BDV-REF-AUTO] ❌ Error en confirmación automática:', error);
      this.simplifiedFlow.loading = false;
    }
  } else {
    console.log('[BDV-REF-AUTO] ⏳ Referencia incompleta o inválida, esperando...');
  }
};

verifyPaymentBDV = async () => {
  // Si no está loading ya (búsqueda manual), activarlo
  if (!this.simplifiedFlow.loading) {
  this.simplifiedFlow.loading = true;
  }

  try {
    // Usar fecha seleccionada en el formulario
    const dateStr = this.formatDateForBDV(this.date_base);
    
    // Construir teléfono completo - usar datos del formulario tradicional
    const fullPhone = this.form.get('code_phone')?.value + this.form.get('phone')?.value;
    
    // Usar monto del formulario tradicional
    const amount = this.form.get('total_amount')?.value;
    
    console.log('[BDV] 📊 Datos para verificación:', { fullPhone, amount, dateStr });
    
    const response = await this._user.verifyPaymentBDV(
      fullPhone,
      amount,
      dateStr
    );

    console.log('[BDV] Verificación response:', response);

    if (response.success && response.data && response.data.response) {
      const matches = response.data.response.matches;
      console.log('[BDV] 📊 Matches encontrados:', matches);
      
      switch (matches) {
        case 'none':
          this.simplifiedFlow.verification.matches = 'none';
          this.simplifiedFlow.step = 'none-found';
          console.log('[BDV] ❌ No se encontraron pagos. Mostrando campos adicionales del flujo tradicional...');
          alertifyjs.message('No se encontraron pagos automáticamente. Completa los campos adicionales para continuar.');
          break;

        case 'unique':
          this.simplifiedFlow.verification.matches = 'unique';
          this.simplifiedFlow.verification.paymentData = response.data.response.paymentData;
          this.simplifiedFlow.data.paymentToken = response.data.response.paymentToken;
          this.simplifiedFlow.step = 'ready-to-register';
          console.log('[BDV] ✅ Pago único encontrado. Token guardado para registro:', this.simplifiedFlow.data.paymentToken);
          console.log('[BDV] 📊 Payment Data:', response.data.response.paymentData);
          
          // PAGO ÚNICO ENCONTRADO: Avanzar a vista 2 para mostrar botón de confirmar
          this.selectView = 2;
          
          console.log('[BDV] ✅ Pago único encontrado. Avanzando automáticamente a vista 2.');
          //alertifyjs.success('🎯 ¡Pago detectado automáticamente! El sistema ubicó tu transacción. Ya puedes confirmar el pago.');
          break;

        case 'multiple':
          this.simplifiedFlow.verification.matches = 'multiple';
          this.simplifiedFlow.verification.requiresReference = true;
          this.simplifiedFlow.step = 'reference';
          alertifyjs.message('Se encontraron múltiples pagos. Ingresa los últimos dígitos de la referencia.');
          break;
      }
    } else {
      throw new Error(response.message || 'Error en la verificación');
    }

  } catch (error: any) {
    console.error('[BDV] Error en verificación:', error);
    alertifyjs.error('Error al verificar el pago: ' + (error.message || 'Error desconocido'));
    // En caso de error, permitir continuar con flujo tradicional
    this.simplifiedFlow.verification.matches = 'none';
  }

  this.simplifiedFlow.loading = false;
  console.log('[BDV] 🏁 Verificación finalizada. Estado actual:', {
    matches: this.simplifiedFlow.verification.matches,
    step: this.simplifiedFlow.step,
    paymentToken: this.simplifiedFlow.data.paymentToken
  });
};

/**
 * Confirmar pago BDV con referencia (para múltiples pagos encontrados)
 * Filtra los pagos múltiples por referencia y retorna paymentToken si lo encuentra
 */
confirmPaymentBDVWithReference = async () => {
  console.log('[BDV-REF] 🔍 Confirmando pago BDV con referencia...');
  
  try {
    // Mostrar indicador de carga
    this.simplifiedFlow.loading = true;
    
    // Recopilar datos del formulario incluyendo referencia
    const formData = this.form.getRawValue();
    const referenceValue = formData.reference;
    
    if (!referenceValue) {
      alertifyjs.error('Por favor ingresa la referencia.');
      this.simplifiedFlow.loading = false;
      return;
    }
    
    console.log('[BDV-REF] 📋 Datos para verificación con referencia:', {
      date: this.date_base_string,
      phone: `${formData.code_phone}${formData.phone}`,
      amount: formData.total_amount,
      reference: referenceValue
    });
    
    // Llamar al servicio de confirmación con referencia para filtrar múltiples pagos
    const response = await this._user.confirmPaymentBDV(
      `${formData.code_phone}${formData.phone}`,
      formData.total_amount,
      referenceValue,
      this.date_base_string
    );
    
    console.log('[BDV-REF] 📦 Respuesta del servicio:', response);
    
    // ✅ SIEMPRE apagar loading al procesar respuesta
    this.simplifiedFlow.loading = false;
    
    // ================================================================================
    // MANEJO DE RESPUESTA: Tanto success:true como success:false pueden ser válidos
    // - success:true + found:true = Pago encontrado con referencia
    // - success:true + found:false = Referencia no válida (resultado normal)
    // - success:false + found:false = Pago no disponible (resultado normal)
    // Solo error real si no hay estructura de respuesta
    // ================================================================================
    
    // Caso 1: Estructura con response.data.details.details.found
    if (response.data && response.data.details && response.data.details.details) {
      const found = response.data.details.details.found;
      console.log('[BDV-REF] 📋 Respuesta con structure data.details.details:', { found, success: response.success });
      
      if (found === false) {
        console.log('[BDV-REF] ℹ️ Referencia no encontrada (data.details.details) - Transición silenciosa a flujo tradicional');
        this.simplifiedFlow.verification.matches = 'none';
        this.simplifiedFlow.verification.requiresReference = false;
        this.simplifiedFlow.data.paymentToken = null; // ✅ IMPORTANTE: Borrar paymentToken previo
        this.simplifiedFlow.step = 'traditional';
        // ✅ SIN MENSAJE: Transición silenciosa
        return;
      }
    }
    
    // Caso 2: Estructura con response.details.details.details.found (estructura anidada más profunda)
    if (response.details && response.details.details && response.details.details.details) {
      const found = response.details.details.details.found;
      console.log('[BDV-REF] 📋 Respuesta con structure details.details.details:', { found, success: response.success });
      
      if (found === false) {
        console.log('[BDV-REF] ℹ️ Referencia no encontrada (details.details.details) - Transición silenciosa a flujo tradicional');
        this.simplifiedFlow.verification.matches = 'none';
        this.simplifiedFlow.verification.requiresReference = false;
        this.simplifiedFlow.data.paymentToken = null; // ✅ IMPORTANTE: Borrar paymentToken previo
        this.simplifiedFlow.step = 'traditional';
        // ✅ SIN MENSAJE: Transición silenciosa
        return;
      }
    }
    
    if (response.data && response.data.response) {
      // Caso normal: success:true con response
      const paymentToken = response.data.response?.paymentToken;
      const found = response.data.response?.found;
      
      console.log('[BDV-REF] 🎯 Respuesta confirmación normal:', { found, paymentToken: !!paymentToken });
      
      if (found && paymentToken) {
        // ✅ ÉXITO: Referencia válida - Pago encontrado y confirmado
        console.log('[BDV-REF] ✅ Referencia válida - Pago confirmado con paymentToken');
        this.simplifiedFlow.verification.matches = 'unique';
        this.simplifiedFlow.verification.requiresReference = false;
        this.simplifiedFlow.data.paymentToken = paymentToken;
        this.simplifiedFlow.step = 'ready-to-register';
        
        // PAGO CONFIRMADO CON REFERENCIA: Avanzar a vista 2 para mostrar botón de confirmar
        this.selectView = 2;
        
        alertifyjs.success('🎯 ¡Pago detectado automáticamente! El sistema ubicó tu transacción con la referencia. Ya puedes confirmar el pago.');
      } else {
        // ℹ️ RESULTADO NORMAL: Referencia no válida - ir a flujo tradicional
        console.log('[BDV-REF] ℹ️ Referencia no encontrada en respuesta normal - Transición silenciosa a flujo tradicional');
        this.simplifiedFlow.verification.matches = 'none';
        this.simplifiedFlow.verification.requiresReference = false;
        this.simplifiedFlow.data.paymentToken = null; // ✅ IMPORTANTE: Borrar paymentToken previo
        this.simplifiedFlow.step = 'traditional';
        // ✅ SIN MENSAJE: Transición silenciosa
      }
    } else {
      // ================================================================================
      // CASO GENERAL: Cualquier respuesta sin estructura conocida = NO ENCONTRADO
      // NO es error, es simplemente que no se encontró la referencia
      // ================================================================================
      console.log('[BDV-REF] ℹ️ Respuesta sin estructura conocida - Asumir no encontrado, transición silenciosa');
      this.simplifiedFlow.verification.matches = 'none';
      this.simplifiedFlow.verification.requiresReference = false;
      this.simplifiedFlow.data.paymentToken = null; // ✅ IMPORTANTE: Borrar paymentToken previo
      this.simplifiedFlow.step = 'traditional';
      // ✅ SIN MENSAJE: Transición silenciosa
      return;
    }
    
  } catch (error: any) {
    // ❌ Solo captura errores REALES de JavaScript (parsing, network, etc.)
    // NO respuestas de API como "no encontrado"
    console.error('[BDV-REF] ❌ Error REAL de JavaScript/Red en verificación:', error);
    this.simplifiedFlow.loading = false;
    
    // ⚠️ ÚLTIMO RECURSO: Solo para errores críticos de código/red
    // NO mostrar mensaje, hacer transición silenciosa también
    console.log('[BDV-REF] 🔇 Error crítico - Transición silenciosa a flujo tradicional');
    this.simplifiedFlow.verification.matches = 'none';
    this.simplifiedFlow.data.paymentToken = null;
    this.simplifiedFlow.step = 'traditional';
    // ✅ SIN MENSAJE ROJO: Incluso para errores reales
  }
};

/**
 * Confirmar pago específico con referencia
 */
confirmPaymentBDV = async () => {
  this.simplifiedFlow.loading = true;

  try {
    const dateStr = this.formatDateForBDV(new Date());
    
    // Construir teléfono completo
    const fullPhone = this.simplifiedFlow.data.phoneCode! + this.simplifiedFlow.data.phoneNumber!;
    
    const response = await this._user.confirmPaymentBDV(
      fullPhone,
      this.simplifiedFlow.data.amount!,
      this.simplifiedFlow.data.reference!,
      dateStr
    );

    console.log('[BDV] Confirmación response:', response);

    if (response.success && response.data && response.data.found) {
      this.simplifiedFlow.verification.paymentData = response.data.paymentData;
      this.simplifiedFlow.data.paymentToken = response.data.paymentToken;
      this.simplifiedFlow.step = 'upload';
      alertifyjs.success('¡Pago confirmado! Sube tu comprobante para finalizar.');
    } else {
      alertifyjs.error('No se encontró el pago con la referencia proporcionada.');
      this.simplifiedFlow.step = 'reference'; // Quedarse en el mismo paso
    }

  } catch (error: any) {
    console.error('[BDV] Error en confirmación:', error);
    alertifyjs.error('Error al confirmar el pago: ' + (error.message || 'Error desconocido'));
  }

  this.simplifiedFlow.loading = false;
};

/**
 * Registrar pago final con paymentToken
 */
registerPaymentBDV = async () => {
  this.simplifiedFlow.loading = true;

  try {
    // Construir teléfono completo
    const fullPhone = this.simplifiedFlow.data.phoneCode! + this.simplifiedFlow.data.phoneNumber!;
    
    // Construir los datos del pago usando el flujo tradicional del componente
    const paymentData = {
      currency: this.formData.moneda,
      description: `Pago Móvil BDV - ${fullPhone}`,
      payment_method: this.account.payment_method._id,
      reference: this.simplifiedFlow.data.reference || 'AUTO-BDV',
      total_amount: parseFloat(this.simplifiedFlow.data.amount!),
      code_person: this.person.code,
      code_account_payment: this.account.code,
      date_register: new Date().toISOString(),
      type: 'AUTO',
      paymentToken: this.simplifiedFlow.data.paymentToken
    };

    const response = await this._user.registerPaymentWithToken(
      paymentData,
      this.simplifiedFlow.data.paymentToken!
    );

    console.log('[BDV] Registro response:', response);

    if (response.success || response.resp) {
      this.simplifiedFlow.step = 'success';
      alertifyjs.success('¡Pago registrado exitosamente!');
      
      // Reset del flujo después de un momento
      setTimeout(() => {
        this.resetSimplifiedFlow();
        this.simplifiedFlow.step = 'phone';
        this.simplifiedFlow.enabled = false;
      }, 3000);
    } else {
      throw new Error(response.message || 'Error al registrar el pago');
    }

  } catch (error: any) {
    console.error('[BDV] Error en registro:', error);
    alertifyjs.error('Error al registrar el pago: ' + (error.message || 'Error desconocido'));
  }

  this.simplifiedFlow.loading = false;
};

/**
 * Formatear fecha para el servicio BDV
 */
formatDateForBDV = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Manejar selección de archivo
 */
onFileSelectedBDV = (event: any) => {
  const file = event.target.files[0];
  if (file) {
    this.simplifiedFlow.data.file = file;
    this.simplifiedFlow.errors.file = '';
    console.log('[BDV] Archivo seleccionado:', file.name);
  }
};

/**
 * Volver al formulario tradicional
 */
switchToTraditionalForm = () => {
  this.simplifiedFlow.enabled = false;
  this.resetSimplifiedFlow();
  alertifyjs.message('Cambiando al formulario tradicional...');
};

// ================================================================================
// MÉTODO PARA RESETEAR FLUJO BDV CUANDO CAMBIAN DATOS PRINCIPALES
// ================================================================================
resetBDVFlowOnDataChange = () => {
  console.log('🔄 [RESET-BDV] Reseteando flujo BDV por cambio en datos principales...');
  
  // Limpiar paymentToken y datos de verificación
  this.simplifiedFlow.data.paymentToken = null;
  this.simplifiedFlow.verification.matches = null;
  this.simplifiedFlow.verification.paymentData = null;
  this.simplifiedFlow.verification.requiresReference = false;
  this.simplifiedFlow.step = 'initial';
  
  // Volver a vista 1 si estamos en vista 2
  if (this.selectView === 2) {
    this.selectView = 1;
  }
  
  // Limpiar errores
  this.simplifiedFlow.errors = {
    phone: '',
    amount: '',
    reference: '',
    file: ''
  };
  
  console.log('🔄 [RESET-BDV] Flujo BDV reseteado. PaymentToken eliminado.');
};

/**
 * Método para permitir solo números en campos de texto
 * @param event - Evento de teclado
 */
onlyNumbers(event: KeyboardEvent): boolean {
  const charCode = event.which ? event.which : event.keyCode;
  // Permitir: backspace, delete, tab, escape, enter
  if ([8, 9, 27, 13, 46].indexOf(charCode) !== -1 ||
      // Permitir: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X, Ctrl+Z
      (charCode === 65 && (event.ctrlKey || event.metaKey)) ||
      (charCode === 67 && (event.ctrlKey || event.metaKey)) ||
      (charCode === 86 && (event.ctrlKey || event.metaKey)) ||
      (charCode === 88 && (event.ctrlKey || event.metaKey)) ||
      (charCode === 90 && (event.ctrlKey || event.metaKey)) ||
      // Permitir: home, end, left, right
      (charCode >= 35 && charCode <= 40)) {
    return true;
  }
  // Asegurar que es un número (0-9)
  if (charCode < 48 || charCode > 57) {
    event.preventDefault();
    return false;
  }
  return true;
}

/**
 * Método para validar el contenido pegado y permitir solo números
 * @param event - Evento de pegado
 */
onPasteNumbers(event: ClipboardEvent): void {
  event.preventDefault();
  const pastedText = event.clipboardData?.getData('text');
  if (pastedText) {
    // Remover todo lo que no sean números
    const numbersOnly = pastedText.replace(/[^0-9]/g, '');
    // Obtener el elemento actual
    const target = event.target as HTMLInputElement;
    if (target && numbersOnly) {
      // Actualizar el valor del control del formulario
      const controlName = target.getAttribute('formControlName');
      if (controlName && this.form.get(controlName)) {
        this.form.get(controlName)?.setValue(numbersOnly);
      }
    }
  }
}


}


